import Pickr from "@simonwep/pickr";
import $ from "jquery";
import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import {
  GetGroup,
  getSubsystemSummary,
  hideIcon,
  pergola,
  greenHouseConst,
  showIcon,
  showHotspotsForAccessory,
  showHotspotsForAutomatedOpening,
  showHotspotsForExtraDoor,
  showHotspotsForDownpipes,
  hideAllAccessoryHotspots,
  applyBackDoorSide,
  getCurrentSizeCode,
  getPlacedAutoWindowClones,
  removePlacedAccessory,
  theModel,
  getActiveBuildParams,
} from "../../core/3d-configurator";
import { IMPORTED_MODELS_GLTF, requestRender } from "../../core/3d-scene";
import { removeFromUrlSystemBySideAndtype } from "../../core/customFunctions/initiSubSystem";
import { state, ACCESSORIES_DATA } from "../../core/settings";
import { deleteActiveClassFromContainerRadioType } from "../interface/interface";
import { updateTextParam, buildSummaryContent } from "../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import { refreshCartTotal } from "../summary/summary-button/summaryButton";
import { generateRangeHTML } from "../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";
import "./portals.scss";

let dpToggling = false;

// Veil fold animation:
let veilFoldIsOpen = false;
let veilFoldClones = [];
let veilHiddenRoots = [];
const VEIL_OPACITY = 0.75;
const VEIL_FOLD_GLB = 'public/models/shadow_veil_fold.glb';
const veilFoldLoader = new GLTFLoader();

export const lightRange = [
  {
    title: "Spacing",
    min: 2,
    max: 8,
    step: 1,
    thumb: true,
    initialValue: state.recessedLighting,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shadesRange = [
  {
    title: "Shades",
    min: 1,
    labelMin: "0",
    max: 90,
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const bladeRotation = [
  {
    title: "Roof Settings",
    min: 1,
    labelMin: "0",
    max: 170,
    step: 1,
    thumb: false,
    initialValue: state.currentRotationZ,
    showLabels: true,
    showSwitchAngle: false,
  },
];


export const louversOpening = [
  {
    title: "louversRange",
    min: 0,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.louversOpeningInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];


export const slidingDoor = [
  {
    title: "Slide Glass Doors:",
    min: 0,
    labelMin: "Open",
    max: 97,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.slidingDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const slidingShutters = [
  {
    title: "Aluminum Sliding Shutters:",
    min: 0,
    labelMin: "Open",
    max: 100,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const zipShadeRange = [
  {
    title: "Blinds and Shades:",
    min: 0,
    labelMin: "Open",
    max: 100,
    labelMax: "Close",
    step: 1,
    thumb: false,
    initialValue: state.zipInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldDoorRange = [
  {
    title: "bi-fold",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const shuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const fixShuttersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 180,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.slidingFixShuttersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShatters = [
  {
    title: "Open",
    min: 1,
    labelMin: "Close",
    max: 100,
    labelMax: "Open",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersInput,
    showLabels: true,
    showSwitchAngle: false,
  },
];

export const biFoldShattersRotate = [
  {
    title: "Rotate",
    min: 1,
    labelMin: "0",
    max: 100,
    labelMax: "180",
    step: 1,
    thumb: false,
    initialValue: state.biFoldDoorShattersRotate,
    showLabels: true,
    showSwitchAngle: false,
  },
];

function createHandleRange(
  compare,
  portalContainer,
  stateKey,
  inputSelector = ".range__input"
) {
  if (compare) {
    const $rangeInput = portalContainer.find(inputSelector);

    // ✅ INIT
    $rangeInput.val(state[stateKey]);

    const min = parseInt($rangeInput.attr("min"), 10);
    const max = parseInt($rangeInput.attr("max"), 10);
    const value = parseInt($rangeInput.val(), 10);

    // ✅ INIT BG
    const percentValue =
      Math.round(((value - min) / (max - min)) * 100 * 100) / 100;
    $rangeInput.css(
      "background",
      `linear-gradient(to right, #629A33 ${percentValue}%, #629A334D ${percentValue}%)`
    );

    // ✅ INIT thumb
    const $rangeThumbValue = portalContainer.find("#range__thumb-value");

    const borderForHide = 2;

    if ($rangeThumbValue) {
      if (
        (value >= min &&
          value <= min + borderForHide &&
          max - min > borderForHide * 2) ||
        (value >= max - borderForHide &&
          value <= max &&
          max - min > borderForHide * 2)
      ) {
        $rangeThumbValue.hide();
      } else {
        $rangeThumbValue.show();
        $rangeThumbValue.text(`${value}%`);

        const percent = ((value - min) / (max - min)) * 100;
        const thumbOffset = $rangeThumbValue.outerWidth();
        $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
      }

      if (value === min || value === max) {
        $rangeThumbValue.hide();
      }
    }

    // ✅ HANDLE "input"
    $rangeInput.on("input", function (event) {
      if (state.roofType === 1 && state.portalOption === 10 && stateKey === "currentRotationZ" && Number(state.louversOpeningInput) > 0) {
        return;
      }
      const $rangeInput = $(this);
      state[stateKey] = +event.target.value;

      const min = parseInt($rangeInput.attr("min"), 10);
      const max = parseInt($rangeInput.attr("max"), 10);
      const value = parseInt($rangeInput.val(), 10);

      const percentValue =
        Math.round(((value - min) / (max - min)) * 100 * 100) / 100;

      $rangeInput.css(
        "background",
        `linear-gradient(to right, #629A33 ${percentValue}%, #629A334D ${percentValue}%)`
      );

      const $rangeThumbValue = portalContainer.find("#range__thumb-value");

      if ($rangeThumbValue) {
        if (
          (value >= min &&
            value <= min + borderForHide &&
            max - min > borderForHide * 2) ||
          (value >= max - borderForHide &&
            value <= max &&
            max - min > borderForHide * 2)
        ) {
          $rangeThumbValue.hide();
        } else {
          $rangeThumbValue.show();
          $rangeThumbValue.text(`${value}%`);

          const percent = ((value - min) / (max - min)) * 100;
          const thumbOffset = $rangeThumbValue.outerWidth() / 2;
          $rangeThumbValue.css("left", `calc(${percent}% - ${thumbOffset}px)`);
        }

        if (value === min || value === max) {
          $rangeThumbValue.hide();
        }
      }

      pergola.update();
    });
  }
}

function removeHandle(
  portalContainer,
  portalContentTitle,
  key,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const moodLight = $(".type_interface_electronic")
      .find(".option")
      .eq(indexOfMenu);

    moodLight.removeClass("type_interface_electronic_item--active");

    state[key] = false;
    state.electro.delete(portalContentTitle);

    updateTextParam(state, moodLight, true);

    hideIcon(typeIndex);

    $(".portal-container").hide();

    state.currentActiveSystems = null;

    $(".interface-container").removeClass("interface-container-portal");

    pergola.update();
  });
}

function removeHandleSystem(
  portalContainer,
  portalContentTitle,
  key,
  indexOfMenu,
  typeIndex
) {
  portalContainer.find(".portal-container__remove").on("click", function () {
    const lastSpan = state.lastSpan;
    if (!lastSpan) return;

    pergola.removeSystemFromSpan(lastSpan);

    removeFromUrlSystemBySideAndtype(
      lastSpan.side,
      state.currentActiveSystems,
      lastSpan.number
    );

    if (!pergola.checkSystemInAllSpans(state.currentActiveSystems)) {
      hideIcon(typeIndex);
      $(".portal-container").hide();

      const subSystems = $(`#last-group #${typeIndex}`);

      subSystems.removeClass("type_interface_electronic_item--active");
      subSystems.find("input[type='radio']").prop("checked", false);

      state[key].delete(portalContentTitle);

      subSystems
        .closest(".interface__group")
        .find(".interface__group__head__param")
        .text(`${updateTextParam(state, this, true, true, true)}`);

      state.currentActiveSystems = null;
    } else {
      $(".portal-container__close").trigger("click");
    }

    $(".interface-container").removeClass("interface-container-portal");
    pergola.update();
  });
}

export const typePortalOption = {
  "LED Lights": "LED Lights",
  Heater: "Heater",
};

export function portalComponent() {
  $(document).off('click.colorBox').on('click.colorBox', '.colors_picker_color', function () {
    $(this).next().trigger('click');
  });

  const bladeRange = generateRangeHTML(bladeRotation[0]).html();
  const louversRange = generateRangeHTML(louversOpening[0]).html();
  const zipRange = generateRangeHTML(zipShadeRange[0]).html();
  const slidingDoorRange = generateRangeHTML(slidingDoor[0]).html();
  const slidingShuttersRange = generateRangeHTML(slidingShutters[0]).html();
  const biFoldRange = generateRangeHTML(biFoldDoorRange[0]).html();
  const shuttersRotateRange = generateRangeHTML(shuttersRotate[0]).html();
  const fixShuttersRotateRange = generateRangeHTML(fixShuttersRotate[0]).html();
  const biFoldShattersRange = generateRangeHTML(biFoldShatters[0]).html();
  const biFoldShattersRotateRange = generateRangeHTML(
    biFoldShattersRotate[0]
  ).html();

  const modelId = $("#ar_model_viewer");
  const mainContent = $("#content");

  function portalGenerete(forceOpen = false) {
    window.portalGenerete = portalGenerete;
    const existingPortal = mainContent.find(".portal-container");

    // Only auto-refresh if the portal is already visible; never open it automatically.
    // forceOpen=true is only passed by the icon click handler (explicit user action).
    if (!forceOpen && (existingPortal.length === 0 || !existingPortal.is(':visible'))) {
      return null;
    }

    // Preserve position so re-generated portal stays in the same spot.
    // Use .offset() (document-relative) so jQuery handles offset-parent math on restore.
    let savedOffset = null;
    if (existingPortal.length > 0) {
      // Only save if the portal was explicitly positioned (has inline top or left set by the icon click handler)
      if (existingPortal[0].style.top || existingPortal[0].style.left) {
        savedOffset = existingPortal.offset();
      }
      existingPortal.remove();
    }

    let portaInnerHtml = "";
    let portalStyle = '';

    switch (state.portalOption) {
      case 7:
        portaInnerHtml = `
          <h3 class="portal-container__title">Mood Light</h3>
            <div class="type_interface_colors-buttons-led">
            <h3  class="portal-container__title__sub-title">Color</h3>
           
            <div class="type_interface_colors-buttons-led__options">
               <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #ffffff">
                    </div>
                    <span class="color-name">White</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>

            <div class="type_interface_colors-buttons-led__item option">
                <label class="type_interface_colors-buttons-led__label">
                    <div class="image-container" style="background-color: #FAFFC4">
                    </div>
                    <span class="color-name">Yellow</span>
                    <input class="type_interface_colors-buttons-led__option" type="radio" id="C34Bronze" name="fav_language" value="Oak">
                </label>
            </div>
            </div>
         
            <div class="colors_picker_container">
                <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorLed}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Color Picker
                </div>
        
                <div id="color-picker-container"></div>
            </div>
        </div>

           

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case 6:
        portaInnerHtml = `
          <h3 class="portal-container__title">LED Lights</h3>
            <h3  class="portal-container__title__sub-title">Frequency</h3>

            <div class="main_container">
            <div class="text">Every</div>

            <ul class="radio__container">
              <li class="radio__container__item ">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">3</span>
              </li>

              <li class="radio__container__item">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">4</span>
              </li>

              <li class="radio__container__item">
                <div class="radio__container__item__cyrcle"></div>

                <span class="radio__container__item__text">5</span>
              </li>
            </ul>

            <div class="text">louvers</div>
            </div>
          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case greenHouseConst.accessoriesType.autoShade:
        portaInnerHtml = `
    <h3 class="portal-container__title">${greenHouseConst.accessoriesNameString.autoShade}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorZip}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorZip}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Pick the Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="zip-range_wrap">
          ${zipRange}
          </div>

         <span class="portal-container__remove">Remove</span>
        `;
        break;


      case greenHouseConst.accessoriesType.slidingGlassDoor:
        portaInnerHtml = `
    <h3 class="portal-container__title">${greenHouseConst.accessoriesNameString.slidingGlassDoor}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorSladditec}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorSladditec}">
                </div>
                
                <div class="colors_picker_button ${state.portalOption === greenHouseConst.accessoriesType.slidingGlassDoor ? 'colors_picker_button--wide' : ''}" id="color-picker">
                    Pick Glass Frame Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="sliding-door-range_wrap">
          ${slidingDoorRange}
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case greenHouseConst.accessoriesType.privacyWall:
        portaInnerHtml = `
    <h3 class="portal-container__title">${greenHouseConst.accessoriesNameString.privacyWall}</h3>

             <div class="portal-container__description">
                <span class="">Selected Color</span>
                <span class="colorShade">${state.colorShutters}</span>
                </div>


          <div class="colors_picker_container">
              <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorShutters}">
                </div>
                
                <div class="colors_picker_button" id="color-picker">
                    Pick the Color
                </div>
        
                <div id="color-picker-container"></div>
          </div>


          <div class="portal-container__range" id="zip-range_wrap">
          ${slidingShuttersRange}
          </div>

          <span class="portal-container__remove">Remove</span>
        `;
        break;

      case 10: {
        const doorVentSection = ACCESSORIES_DATA.find(s => s.id === 'ventilation');
        const mosquitoItem = doorVentSection?.items.find(i => i.key === 'mosquitoDoor');
        const extraDoorItem = doorVentSection?.items.find(i => i.key === 'extraDoor');
        const extraDblItem = doorVentSection?.items.find(i => i.key === 'extraDoubleDoor');
        const mosquitoSelected = state.subAccessoriesUrl.has('mosquitoDoor');
        const extraDoorSelected = state.subAccessoriesUrl.has('extraDoor');
        const extraDblSelected = state.subAccessoriesUrl.has('extraDoubleDoor');

        const doorSelectedCount = [mosquitoSelected, extraDoorSelected, extraDblSelected].filter(Boolean).length;
        if (doorSelectedCount === 3) portalStyle = 'max-height:386px';

        const buildDoorPairs = (key, item) => {
          const placed = pergola.getPlacedAccessories().filter(p => p.accessoryKey === key);
          return placed.map(p => `
            <div class="portal-vent-action" data-key="${key}" data-zone="${p.zone}" data-span="${p.spanIndex}">
              <div class="portal-vent-action__img-wrap">
                <img src="${item?.img || ''}" class="portal-vent-action__img">
                <div class="portal-vent-action__cancel"
                     data-action="removePlaced" data-key="${key}" data-zone="${p.zone}" data-span="${p.spanIndex}"></div>
              </div>
            </div>`).join('');
        };

        portaInnerHtml = `
          <h3 class="portal-container__title">Door Settings</h3>
          <div class="portal-door-settings">
            <button class="portal-door-btn portal-door-btn--left portal-door-btn--active" data-side="left">
              <img src="public/img/icons/marevo-icon-doorLeft-active.svg" alt="Open left">
            </button>
            <button class="portal-door-btn portal-door-btn--right" data-side="right">
              <img src="public/img/icons/marevo-icon-doorRight.svg" alt="Open right">
            </button>
            <button class="portal-door-btn portal-door-btn--anim" data-side="anim">
              <img src="public/img/icons/marevo-icon-door-animation.svg" alt="Animate door">
            </button>
          </div>

          ${mosquitoSelected ? `
          <div class="portal-auto-vent-group">
            <h4 class="portal-auto-vent-group__title">
              <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Mosquito door:
              <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="mosquitoDoor">
            </h4>
            <hr class="portal-auto-vent-group__divider">
            <div class="portal-auto-vent-group__cards">${buildDoorPairs('mosquitoDoor', mosquitoItem)}<button class="portal-auto-vent-group__add-btn" data-key="mosquitoDoor"></button></div>
          </div>` : ''}

          ${extraDoorSelected ? `
          <div class="portal-auto-vent-group">
            <h4 class="portal-auto-vent-group__title">
              <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Extra single door:
              <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="extraDoor">
            </h4>
            <hr class="portal-auto-vent-group__divider">
            <div class="portal-auto-vent-group__cards">${buildDoorPairs('extraDoor', extraDoorItem)}<button class="portal-auto-vent-group__add-btn" data-key="extraDoor"></button></div>
          </div>` : ''}

          ${extraDblSelected ? `
          <div class="portal-auto-vent-group">
            <h4 class="portal-auto-vent-group__title">
              <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Extra single door for double opening:
              <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="extraDoubleDoor">
            </h4>
            <hr class="portal-auto-vent-group__divider">
            <div class="portal-auto-vent-group__cards">${buildDoorPairs('extraDoubleDoor', extraDblItem)}<button class="portal-auto-vent-group__add-btn" data-key="extraDoubleDoor"></button></div>
          </div>` : ''}
        `;
        break;
      }

      case 11: {
        const ventSection = ACCESSORIES_DATA.find(s => s.id === 'ventilation');
        const autoItem = ventSection?.items.find(i => i.key === 'automateOpening');
        const roofWinItem = ventSection?.items.find(i => i.key === 'roofWindow');
        const sideWinItem = ventSection?.items.find(i => i.key === 'sideWindow');
        const backWinItem = ventSection?.items.find(i => i.key === 'backWindow');
        const autoSelected = state.subAccessoriesUrl.has('automateOpening');
        const roofWinSelected = state.subAccessoriesUrl.has('roofWindow');
        const sideWinSelected = state.subAccessoriesUrl.has('sideWindow');
        const backWinSelected = state.subAccessoriesUrl.has('backWindow');

        portaInnerHtml = `
          <h3 class="portal-container__title">Ventilation</h3>
          <div class="portal-ventilation">

            <div class="portal-auto-vent-group">
              <h4 class="portal-auto-vent-group__title">
              <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Automated opening:
              <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon${autoSelected ? '' : ` disabled`}" data-animkey="automateOpening">
            </h4>

              <hr class="portal-auto-vent-group__divider">
              <div class="portal-auto-vent-group__cards">
                <div class="portal-vent-action${autoSelected ? '' : ' portal-vent-action--disabled'}" data-action="removeAuto">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${autoItem?.img || ''}" class="portal-vent-action__img">
                    <div class="portal-vent-action__cancel"></div>
                  </div>
                </div>
              </div>
            </div>

            ${roofWinSelected ? (() => {
            const placed11Roof = pergola.getPlacedAccessories().filter(p => p.accessoryKey === 'roofWindow' && !p.permanent);
            const filledRoof = placed11Roof.map(p => `
                <div class="portal-vent-action" data-key="roofWindow" data-zone="${p.zone}" data-span="${p.spanIndex}">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${roofWinItem?.img || ''}" class="portal-vent-action__img">
                    <div class="portal-vent-action__cancel" data-action="removePlaced11" data-key="roofWindow" data-zone="${p.zone}" data-span="${p.spanIndex}"></div>
                  </div>
                </div>`).join('');
            return `
            <div class="portal-auto-vent-group">
              <h4 class="portal-auto-vent-group__title">
                <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Extra roof window:
                <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="roofWindow">
              </h4>
              <hr class="portal-auto-vent-group__divider">
              <div class="portal-auto-vent-group__cards">
                ${filledRoof}<button class="portal-auto-vent-group__add-btn" data-key="roofWindow"></button>
              </div>
            </div>`;
          })() : ''}

            ${sideWinSelected ? (() => {
            const placed11Side = pergola.getPlacedAccessories().filter(p => p.accessoryKey === 'sideWindow');
            const filledSide = placed11Side.length > 0
              ? placed11Side.map(p => `
                <div class="portal-vent-action" data-key="sideWindow" data-zone="${p.zone}" data-span="${p.spanIndex}">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${sideWinItem?.img || ''}" class="portal-vent-action__img">
                    <div class="portal-vent-action__cancel" data-action="removePlaced11" data-key="sideWindow" data-zone="${p.zone}" data-span="${p.spanIndex}"></div>
                  </div>
                </div>`).join('')
              : `<div class="portal-vent-action" data-key="sideWindow">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${sideWinItem?.img || ''}" class="portal-vent-action__img">
                  </div>
                </div>`;
            return `
            <div class="portal-auto-vent-group">
              <h4 class="portal-auto-vent-group__title">
                <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Side window:
                <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="sideWindow">
              </h4>
              <hr class="portal-auto-vent-group__divider">
              <div class="portal-auto-vent-group__cards">
                ${filledSide}<button class="portal-auto-vent-group__add-btn" data-key="sideWindow"></button>
              </div>
            </div>
            
           <div class="portal-auto-vent-group__cards__sideWindow">
               <div class="sideWindow_control">
                <span class="sideWindow_control_title">Control Mode:</span>
                <div class="sideWindow_tumbler">
                  <img src="public/img/icons/marevo-icon-side-window-manual.svg" class="toggle-label${state.windowModes.sideWindow === 'manual-window' ? ' active' : ''}" data-option="manual-window">
                  <div class="toggle-switch" data-window-key="sideWindow" data-option="${state.windowModes.sideWindow}">
                    <div class="toggle-knob${state.windowModes.sideWindow === 'auto-window' ? ' toggle-knob--right' : ''}"></div>
                  </div>
                  <img src="public/img/icons/marevo-icon-side-window-auto.svg" class="toggle-label${state.windowModes.sideWindow === 'auto-window' ? ' active' : ''}" data-option="auto-window">
                </div>
                <span class="window-mode-label">${state.windowModes.sideWindow === 'manual-window' ? 'Manual Side Windows' : 'Automatic Side Window'}</span>
              </div>
            </div>
            `;
          })() : ''}

            ${backWinSelected ? (() => {
            const placedBackWin = pergola.getPlacedAccessories().filter(p => p.accessoryKey === 'backWindow');
            const filledBack = placedBackWin.length > 0
              ? placedBackWin.map(p => `
                <div class="portal-vent-action" data-key="backWindow" data-zone="${p.zone}" data-span="${p.spanIndex}">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${backWinItem?.img || ''}" class="portal-vent-action__img">
                    <div class="portal-vent-action__cancel" data-action="removePlaced11" data-key="backWindow" data-zone="${p.zone}" data-span="${p.spanIndex}"></div>
                  </div>
                </div>`).join('')
              : `<div class="portal-vent-action" data-key="backWindow">
                  <div class="portal-vent-action__img-wrap">
                    <img src="${backWinItem?.img || ''}" class="portal-vent-action__img">
                  </div>
                </div>`;
            return `
            <div class="portal-auto-vent-group">
              <h4 class="portal-auto-vent-group__title">
                <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> Back window:
                <img src="public/img/icons/marevo-icon-door-animation.svg" class="portal-auto-vent-group__icon" data-animkey="backWindow">
              </h4>
              <hr class="portal-auto-vent-group__divider">
              <div class="portal-auto-vent-group__cards">
                ${filledBack}<button class="portal-auto-vent-group__add-btn" data-key="backWindow"></button>
              </div>
            </div>
            
            <div class="portal-auto-vent-group__cards__sideWindow">
               <div class="sideWindow_control">
                 <span class="sideWindow_control_title">Control Mode:</span>
                  <div class="sideWindow_tumbler">
                    <img src="public/img/icons/marevo-icon-side-window-manual.svg" class="toggle-label${state.windowModes.backWindow === 'manual-window' ? ' active' : ''}" data-option="manual-window">
                    <div class="toggle-switch" data-window-key="backWindow" data-option="${state.windowModes.backWindow}">
                      <div class="toggle-knob${state.windowModes.backWindow === 'auto-window' ? ' toggle-knob--right' : ''}"></div>
                    </div>
                    <img src="public/img/icons/marevo-icon-side-window-auto.svg" class="toggle-label${state.windowModes.backWindow === 'auto-window' ? ' active' : ''}" data-option="auto-window">
                  </div>
                  <span class="window-mode-label">${state.windowModes.backWindow === 'manual-window' ? 'Manual Rear Window' : 'Automatic Rear Window'}</span>
              </div>
            </div>
            `;
          })() : ''}
          </div>
        `;
        break;
      }

      case 12: {
        const organizationSection = ACCESSORIES_DATA.find(s => s.id === 'organization');
        const selectedOrgItems = (organizationSection?.items ?? []).filter(i => state.subAccessoriesUrl.has(i.key));

        const buildOrgPairs12 = (key, item) => {
          const placed = pergola.getPlacedAccessories().filter(p => p.accessoryKey === key);
          return placed.map(p => `
            <div class="portal-vent-action" data-key="${key}" data-zone="${p.zone}" data-span="${p.spanIndex}">
              <div class="portal-vent-action__img-wrap">
                <img src="${item?.img || ''}" class="portal-vent-action__img">
                <div class="portal-vent-action__cancel"
                     data-action="removeOrgPlaced" data-key="${key}" data-zone="${p.zone}" data-span="${p.spanIndex}"></div>
              </div>
            </div>`).join('');
        };

        portaInnerHtml = `
          <h3 class="portal-container__title">Organization</h3>
          ${selectedOrgItems.map(item => `
          <div class="portal-auto-vent-group">
            <h4 class="portal-auto-vent-group__title">
              <img src="public/img/icons/marevo-icon-arrow-play.svg" class="portal-auto-vent-group__arrow" alt=""> ${item.name}:
            </h4>
            <hr class="portal-auto-vent-group__divider">
            <div class="portal-auto-vent-group__cards">${buildOrgPairs12(item.key, item)}<button class="portal-auto-vent-group__add-btn" data-key="${item.key}"></button></div>
          </div>`).join('')}
        `;
        break;
      }

      case 13: {
        const otherSection = ACCESSORIES_DATA.find(s => s.id === 'other');
        const selectedOtherItems = (otherSection?.items ?? []).filter(i => state.subAccessoriesUrl.has(i.key));

        const veilItem = otherSection?.items.find(i => i.key === 'veil');
        const downpipesItem = otherSection?.items.find(i => i.key === 'downpipes');
        const roofDecorItem = otherSection?.items.find(i => i.key === 'roofDecor');

        const veilSelected = state.subAccessoriesUrl.has('veil');
        const downpipesSelected = state.subAccessoriesUrl.has('downpipes');
        const roofDecorSelected = state.subAccessoriesUrl.has('roofDecor');

        const dpExpanded = downpipesSelected;
        const veilExpanded = veilSelected;
        const decorExpanded = roofDecorSelected;

        const curMat = state.downpipeMaterial ?? 'grey_plastic';
        const frontPlaced = pergola.getPlacedAccessories().some(p => p.accessoryKey === 'downpipes' && p.zone === 'wallFront');
        const backPlaced = pergola.getPlacedAccessories().some(p => p.accessoryKey === 'downpipes' && p.zone === 'wallBack');
        const veilPlaced = pergola.getPlacedAccessories().some(p => p.accessoryKey === 'veil');
        const decorPlaced = pergola.getPlacedAccessories().some(p => p.accessoryKey === 'roofDecor');

        const buildSimpleGroup = (item, key, isExpanded, isPlaced) => {
          if (!item) return '';
          const animIcon = (key === 'veil' && isPlaced)
            ? `<img src="public/img/icons/${veilFoldIsOpen ? 'marevo-icon-door-animation-inactive' : 'marevo-icon-door-animation'}.svg" class="portal-auto-vent-group__icon" data-animkey="veil" style="cursor:pointer;width:20px;height:20px;margin-left:6px;">`
            : '';
          return `
          <div class="portal-auto-others-group portal-other-group" data-group="${key}">
            <h4 class="portal-auto-others-group__title portal-other-group__header" data-group="${key}">
               <span class="portal-auto-others-group__arrow">&#9654;</span>  ${item.name}: ${animIcon}
            </h4>
            <div class="portal-other-group__body" style="display:${isExpanded ? 'block' : 'none'}">
              <hr class="portal-auto-others-group__divider">
              <div class="portal-auto-others-group__cards">
                ${isPlaced
              ? `<div class="portal-vent-action" data-key="${key}" data-zone="roof" data-span="0">
                       <div class="portal-vent-action__img-wrap">
                         <img src="${item.img || ''}" class="portal-vent-action__img">
                         <div class="portal-vent-action__cancel" data-action="removeOtherPlaced" data-key="${key}" data-zone="roof" data-span="0"></div>
                       </div>
                     </div>`
              : `<div class="portal-vent-action" data-action="addOtherSimple" data-key="${key}">
                       <div class="portal-vent-action__img-wrap">
                         <img src="${item.img || ''}" class="portal-vent-action__img">
                       </div>
                     </div>`}
              </div>
            </div>
          </div>`;
        };

        const buildDownpipesGroup = () => {
          if (!downpipesItem) return '';

          return `
          <div class="portal-auto-others-group portal-other-group" data-group="downpipes">
            <h4 class="portal-auto-others-group__title portal-other-group__header" data-group="downpipes">
              <span class="portal-auto-others-group__arrow">&#9654;</span>  ${downpipesItem.name}:
            </h4>
            <div class="portal-other-group__body" style="display:${dpExpanded ? 'block' : 'none'}">
              <hr class="portal-auto-others-group__divider">
              <div class="portal-downpipes-position">
                <span class="portal-downpipes-position__label">Position:</span>
                <div class="portal-downpipes-position__controls">
                  <button class="portal-downpipes-pos-btn${frontPlaced ? ' portal-downpipes-pos-btn--active' : ''}" data-dp-zone="wallFront" title="Front wall">
                    <img src="public/img/icons/marevo-icon-downpipe-front.svg" class="">
                  </button>
                  <label class="portal-downpipes-toggle">
                    <input type="checkbox" class="portal-downpipes-toggle__input" id="dp-both-toggle" ${backPlaced ? 'checked' : ''}>
                    <span class="portal-downpipes-toggle__track"></span>
                  </label>
                  <button class="portal-downpipes-pos-btn${backPlaced ? ' portal-downpipes-pos-btn--active' : ''}" data-dp-zone="wallBack" title="Back wall">
                    <img src="public/img/icons/marevo-icon-downpipe-back.svg" class="">
                  </button>
                </div>
              </div>
              <div class="portal-downpipes-materials">
              ${state.colorBody === '#000000' ?
              `
                <div class="portal-downpipes-mat${curMat === 'black_plastic' ? ' portal-downpipes-mat--active' : ''}" data-dp-mat="black_plastic">
                  <div class="portal-downpipes-mat__swatch" style="background:#3a3a3a; border-radius:6px; width:45px; height:30px; border:2px solid ${curMat === 'black_plastic' ? '#2e7d32' : '#e0e0e0'}"></div>
                  <span class="portal-downpipes-mat__label">Black<br>Plastic</span>
                </div>
                <div class="portal-downpipes-mat${curMat === 'black_alum' ? ' portal-downpipes-mat--active' : ''}" data-dp-mat="black_alum">
                  <div class="portal-downpipes-mat__swatch" style="background-image: url(public/img/icons/marevo-alum-blackline.png); background-position: center; border-radius:6px; width:45px; height:30px; border:2px solid ${curMat === 'black_alum' ? '#2e7d32' : '#e0e0e0'}"></div>
                  <span class="portal-downpipes-mat__label">Black<br>Aluminum</span>
                </div>
                `
              :
              `
                <div class="portal-downpipes-mat${curMat === 'grey_plastic' ? ' portal-downpipes-mat--active' : ''}" data-dp-mat="grey_plastic">
                  <div class="portal-downpipes-mat__swatch" style="background:#c8c8c8; border-radius:6px; width:45px; height:30px; border:2px solid ${curMat === 'grey_plastic' ? '#2e7d32' : '#e0e0e0'}"></div>
                  <span class="portal-downpipes-mat__label">Grey<br>Plastic</span>
                </div>
                <div class="portal-downpipes-mat${curMat === 'black_plastic' ? ' portal-downpipes-mat--active' : ''}" data-dp-mat="black_plastic">
                  <div class="portal-downpipes-mat__swatch" style="background:#3a3a3a; border-radius:6px; width:45px; height:30px; border:2px solid ${curMat === 'black_plastic' ? '#2e7d32' : '#e0e0e0'}"></div>
                  <span class="portal-downpipes-mat__label">Black<br>Plastic</span>
                </div>
                <div class="portal-downpipes-mat${curMat === 'black_alum' ? ' portal-downpipes-mat--active' : ''}" data-dp-mat="black_alum">
                  <div class="portal-downpipes-mat__swatch" style="background-image: url(public/img/icons/marevo-alum-blackline.png); background-position: center; border-radius:6px; width:45px; height:30px; border:2px solid ${curMat === 'black_alum' ? '#2e7d32' : '#e0e0e0'}"></div>
                  <span class="portal-downpipes-mat__label">Black<br>Aluminum</span>
                </div>
                `}
              </div>
            </div>
          </div>`;
        };

        portaInnerHtml = `
          <h3 class="portal-container__title">Others</h3>
          ${downpipesSelected ? buildDownpipesGroup() : ''}
          ${veilSelected ? buildSimpleGroup(veilItem, 'veil', veilExpanded, veilPlaced) : ''}
          ${roofDecorSelected ? buildSimpleGroup(roofDecorItem, 'roofDecor', decorExpanded, decorPlaced) : ''}
        `;
        break;
      }

      default:
        break;
    }

    const portalContent = $(`
      <div class="portal-container ${state.portalOption === 10 ? 'portal-container--doors' : ''} ${state.portalOption === 11 ? 'portal-container--ventilation' : ''} ${state.portalOption === 12 ? 'portal-container--organization' : ''} ${state.portalOption === greenHouseConst.accessoriesType.slidingGlassDoor ? 'portal-container--wide' : ''}" ${portalStyle ? `style="${portalStyle}"` : ''}>
        <span class="portal-container__close"></span>
        ${portaInnerHtml}
      </div>
    `);

    const portalContentTitle = portalContent
      .find(`.portal-container__title`)
      .text();

    const activeColorClass = "type_interface_colors-buttons-led__item--active";

    //#region BLADE ROTATION

    function updateBladeBlockedState() {
      const isBladeBlocked = state.roofType === 1 && Number(state.louversOpeningInput) > 0;

      const $bladeRangeInput = portalContent.find('#blade-range_wrap input');

      $bladeRangeInput.prop('disabled', isBladeBlocked);

      portalContent
        .find('#blade-block-wrap')
        .toggleClass('blocked-range', isBladeBlocked);
    };

    const bladeRangeWrap = portalContent.find('#blade-range_wrap');
    if (bladeRangeWrap.length) {
      createHandleRange(true, bladeRangeWrap, "currentRotationZ");
    }

    const louversRangeWrap = portalContent.find('#louvers-range_wrap');
    if (louversRangeWrap.length) {
      createHandleRange(true, louversRangeWrap, "louversOpeningInput");

      updateBladeBlockedState();

      louversRangeWrap.find('.range__input').on('input', function () {
        updateBladeBlockedState();
      });
    }

    // retract option handlers:
    $(document).on('click', '.type_interface_retrect-buttons-louvers__item', function (e) {
      e.preventDefault();

      // Update radio state
      $('.type_interface_retrect-buttons-louvers__item').removeClass('active');
      $('.type_interface_retrect-buttons-louvers__input').prop('checked', false);
      $(this).addClass('active');
      $(this).find('.type_interface_retrect-buttons-louvers__input').prop('checked', true);

      const retractValue = $(this).find('input').val();

      if (retractValue === 'oneSide') {
        state.retractOption = 'oneSide';
      } else {
        state.retractOption = 'twoSides';
      }

      pergola.update();
    });

    //#endregion

    //#region MOOD LIGHT
    if ("Mood Light" === portalContentTitle) {
      const mesh = GetGroup("base").children[1];

      //#region INIT INPUT
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .each(function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .find(".image-container")
              .css("background-color")
          );

          if (state.colorLed === backgroundColor) {
            $(this)
              .closest(".type_interface_colors-buttons-led__item")
              .addClass(activeColorClass);
            $(this).prop("checked", true);
          }
        });
      //#endregion

      //#region HANDLE INPUTS
      portalContent
        .find(".type_interface_colors-buttons-led__item")
        .on("click", function () {
          const backgroundColor = pergola.rgbToHex(
            $(this)
              .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
              .find(".image-container")
              .css("background-color")
          );

          state.colorLed = backgroundColor;

          // Додаємо активний клас
          $(this)
            .closest(".type_interface_colors-buttons-led__item") // оновлений селектор
            .addClass(activeColorClass);

          // Видаляємо активний клас у всіх інших елементах
          $(this)
            .closest(".type_interface_colors-buttons-led") // оновлений селектор
            .find(".type_interface_colors-buttons-led__item") // оновлений селектор
            .not($(this).closest(".type_interface_colors-buttons-led__item")) // оновлений селектор
            .removeClass(activeColorClass);

          // Зміна емісії кольору в mesh
          if (mesh && mesh.material) {
            mesh.material.emissive.set(state.colorLed);

            mesh.children.forEach((child) => {
              if (child.material) {
                child.material.emissive.set(state.colorLed);
              }
            });
          }
        });
      //#endregion

      //#region REMOVE BUTTON
      removeHandle(portalContent, portalContentTitle, "moodLight", 1, 7);
      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-box").css("background-color", state.colorLed);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            portalContent
              .find("#color-box")
              .css("background-color", state.colorLed);

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );

            pergola.update();
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region LED LIGHT
    if ("LED Lights" === portalContentTitle) {
      //#region INIT INPUT
      portalContent.find(".radio__container__item").each(function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        if (state.recessedLighting === louverGap) {
          $(this).closest(".radio__container__item").addClass("active");
        }
      });
      //#endregion

      //#region HANDLE INPUTS
      portalContent.find(".radio__container__item").on("click", function () {
        const louverGap = +$(this).find(".radio__container__item__text").text();

        state.recessedLighting = louverGap;

        portalContent.find(".radio__container__item").each(function () {
          $(this).removeClass("active");
        });

        $(this).addClass("active");

        pergola.update();
      });
      //#endregion

      //#region REMOVE BUTTON

      removeHandle(portalContent, portalContentTitle, "ledLights", 0, 6);
      //#endregion

      //#region HANDLE COLOR PICKER
      let pickr;

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorLed,

            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorLed = selectedColor;

            if (mesh && mesh.material) {
              mesh.material.emissive.set(state.colorLed);

              mesh.children.forEach((child) => {
                if (child.material) {
                  child.material.emissive.set(state.colorLed);
                }
              });
            }

            deleteActiveClassFromContainerRadioType(
              portalContent,
              ".type_interface_colors-buttons-led__item",
              activeColorClass
            );
          });
        }

        pickr.show();
      });

      // #endregion
    }
    //#endregion

    //#region ZIP-SHADE
    if (greenHouseConst.accessoriesNameString.autoShade === portalContentTitle) {
      createHandleRange(true, portalContent, "zipInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorZip);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorZip,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorZip = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        4,
        greenHouseConst.accessoriesType.autoShade
      );

      //#endregion
    }
    //#endregion

    //#region SLIDING GLASS DOOR
    if (greenHouseConst.accessoriesNameString.slidingGlassDoor === portalContentTitle) {
      if (state.width === 1 || state.length === 1) {
        const clampMax = 25;
        portalContent.find('.range__input').attr('max', clampMax);
        if (state.slidingDoorInput > clampMax) {
          state.slidingDoorInput = clampMax;
          portalContent.find('.range__input').val(clampMax);
        }
      }
      createHandleRange(true, portalContent, "slidingDoorInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorSladditec);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorSladditec,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorSladditec = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        0,
        greenHouseConst.accessoriesType.slidingGlassDoor
      );
      //#endregion
    }

    //#endregion

    //#endregion

    //#region SLIDING-SHATTERS
    if (greenHouseConst.accessoriesNameString.privacyWall === portalContentTitle) {
      if (state.width === 1 || state.length === 1) {
        const clampMax = 25;
        portalContent.find('.range__input').attr('max', clampMax);
        if (state.slidingShuttersInput > clampMax) {
          state.slidingShuttersInput = clampMax;
          portalContent.find('.range__input').val(clampMax);
        }
      }
      createHandleRange(true, portalContent, "slidingShuttersInput");

      //#region COLOR PICKER
      let pickr;
      portalContent.find("#color-box").css("background-color", state.colorShutters);

      portalContent.find("#color-picker").on("click", function () {
        if (!pickr) {
          pickr = Pickr.create({
            el: "#color-picker-container",
            theme: "classic",
            default: state.colorShutters,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: false,
                rgba: false,
                input: false,
              },
            },
          });

          pickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString();
            state.colorShutters = selectedColor;
            portalContent.find("#color-box").css("background-color", selectedColor);
            portalContent.find(".portal-container__description span:last-child").text(selectedColor);
            pergola.update();
          });
        }
        pickr.show();
      });
      //#endregion

      //#region REMOVE BUTTON
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        0,
        greenHouseConst.accessoriesType.privacyWall
      );
      //#endregion
    }

    //#endregion

    //#region FIX SHATTERS
    if (greenHouseConst.accessoriesNameString.fix_shutters === portalContentTitle) {
      //ROTATE
      createHandleRange(
        true,
        portalContent,
        "slidingFixShuttersRotate",
        ".range__input"
      );

      //REMOVE
      removeHandleSystem(
        portalContent,
        portalContentTitle,
        "subSystem",
        3,
        greenHouseConst.accessoriesType.fix_shutters
      );
    }
    //#endregion


    //#enregion

    //#region DOOR SETTINGS (case 10)
    if (state.portalOption === 10) {
      let doorMixer = null;
      let doorAnimActive = false;

      const model = theModel;
      const gltf = IMPORTED_MODELS_GLTF.find(g => g?.scene === theModel) ?? IMPORTED_MODELS_GLTF[0];

      if (gltf && gltf.animations && gltf.animations.length > 0) {
        doorMixer = new THREE.AnimationMixer(model);
        // console.log('Door animations:', gltf.animations.map(a => a.name));
        window._doorMixer = doorMixer;
      }

      // Reset door to rest state when popup opens (logos follow via their own animation tracks)
      {
        if (window._meshClickMixers?.length) {
          window._meshClickMixers.forEach(m => m.stopAllAction());
          window._meshClickMixers.length = 0;
        }
        window._mainDoorIsOpen = false;

        // Reset all animated nodes back to their rest state (saved at model load)
        if (gltf?.animations) {
          const propReReset = /\.(position|quaternion|scale|morphTargetInfluences)$/;
          gltf.animations.forEach(clip => {
            clip.tracks.forEach(track => {
              const nodeName = track.name.replace(propReReset, '');
              const node = model?.getObjectByName(nodeName);
              if (node) {
                if (node.userData.restQuat) node.quaternion.copy(node.userData.restQuat);
                if (node.userData.restPos) node.position.copy(node.userData.restPos);
                if (node.userData.restScale) node.scale.copy(node.userData.restScale);
              }
            });
          });
        }
      }

      const doorAnimOpenState = new Map();

      const updateDoorBtns = (activeSide) => {
        portalContent.find('.portal-door-btn').each(function () {
          const side = $(this).data('side');
          const img = $(this).find('img');
          if (side === 'left') {
            img.attr('src', activeSide === 'left'
              ? 'public/img/icons/marevo-icon-doorLeft-active.svg'
              : 'public/img/icons/marevo-icon-doorLeft.svg');
          } else if (side === 'right') {
            img.attr('src', activeSide === 'right'
              ? 'public/img/icons/marevo-icon-doorRight-active.svg'
              : 'public/img/icons/marevo-icon-doorRight.svg');
          } else if (side === 'anim') {
            img.attr('src', activeSide === 'anim'
              ? 'public/img/icons/marevo-icon-door-animation-active.svg'
              : 'public/img/icons/marevo-icon-door-animation.svg');
          }
        });
      };

      portalContent.find('.portal-door-btn').on('click', function () {
        const side = $(this).data('side');
        updateDoorBtns(side);

        if (side === 'left' || side === 'right') {
          const frontWall = model?.getObjectByName('front_wall');
          const leftLogo = model?.getObjectByName('door_mosquito_logo');
          const rightLogo = model?.getObjectByName('door_logo');
          if (frontWall) {
            if (!frontWall.userData.originPos) {
              frontWall.userData.originPos = frontWall.position.clone();
              frontWall.userData.originQuat = frontWall.quaternion.clone();
            }

            // Reset door animation to rest — logos follow via their own tracks
            if (doorMixer) {
              doorMixer.stopAllAction();
              doorMixer.setTime(0);
            }
            doorAnimOpenState.delete('mainDoor');
            window._mainDoorIsOpen = false;
            if (window._backDoorMixer) {
              window._backDoorMixer.stopAllAction();
              window._backDoorMixer.setTime(0);
            }
            // Restore all animated nodes to rest
            if (gltf?.animations) {
              const propReSwitch = /\.(position|quaternion|scale|morphTargetInfluences)$/;
              gltf.animations.forEach(clip => {
                clip.tracks.forEach(track => {
                  const nodeName = track.name.replace(propReSwitch, '');
                  const node = model?.getObjectByName(nodeName);
                  if (node) {
                    if (node.userData.restQuat) node.quaternion.copy(node.userData.restQuat);
                    if (node.userData.restPos) node.position.copy(node.userData.restPos);
                  }
                });
              });
            }

            frontWall.scale.z = side === 'left'
              ? -Math.abs(frontWall.scale.z)
              : Math.abs(frontWall.scale.z);

            const activeBuildParams = getActiveBuildParams();
            const hasDoubleDoor = state.subAccessoriesUrl.has('extraDoubleDoor');
            if (side === 'left') {
              frontWall.position.set(
                (frontWall.userData.originPos?.x ?? 0) + 0.085,
                frontWall.userData.originPos?.y ?? 1.438,
                frontWall.userData.originPos?.z ?? -0.375
              );
              if (!hasDoubleDoor) {
                if (activeBuildParams.doorLogoLeftUsesRight) {
                  if (leftLogo) { leftLogo.visible = false; leftLogo.traverse(o => { if (o.isMesh) o.visible = false; }); }
                  if (rightLogo) {
                    rightLogo.visible = true; rightLogo.traverse(o => { if (o.isMesh) o.visible = true; });
                    rightLogo.scale.x = -1;
                    const doorNodeLeft = model?.getObjectByName('door');
                    if (doorNodeLeft && doorNodeLeft !== model && rightLogo.parent !== doorNodeLeft) {
                      model.updateWorldMatrix(true, true);
                      doorNodeLeft.attach(rightLogo);
                    }
                    rightLogo.position.x = 2 * (rightLogo.userData.logoMeshCenterX ?? 0);
                    rightLogo.userData.restPos = rightLogo.position.clone();
                    rightLogo.userData.restScale = rightLogo.scale.clone();
                    rightLogo.userData.restQuat = rightLogo.quaternion.clone();
                  }
                } else {
                  if (rightLogo) { rightLogo.visible = false; rightLogo.traverse(o => { if (o.isMesh) o.visible = false; }); }
                  if (leftLogo) { leftLogo.visible = true; leftLogo.traverse(o => { if (o.isMesh) o.visible = true; }); }
                }
              }
            } else {
              frontWall.position.set(
                activeBuildParams.frontWallXRight ?? frontWall.userData.originPos?.x ?? 0,
                frontWall.userData.originPos?.y ?? 1.438,
                frontWall.userData.originPos?.z ?? -0.375
              );
              if (!hasDoubleDoor) {
                if (leftLogo) { leftLogo.visible = false; leftLogo.traverse(o => { if (o.isMesh) o.visible = false; }); }
                if (rightLogo) {
                  rightLogo.visible = true; rightLogo.traverse(o => { if (o.isMesh) o.visible = true; });
                  rightLogo.scale.x = 1;
                  if (activeBuildParams.doorLogoLeftUsesRight) {
                    const doorNodeRight = model?.getObjectByName('door');
                    if (doorNodeRight && doorNodeRight !== model && rightLogo.parent !== doorNodeRight) {
                      model.updateWorldMatrix(true, true);
                      doorNodeRight.attach(rightLogo);
                    }
                    rightLogo.position.x = 0;
                  }
                  rightLogo.userData.restPos = rightLogo.position.clone();
                  rightLogo.userData.restScale = rightLogo.scale.clone();
                  rightLogo.userData.restQuat = rightLogo.quaternion.clone();
                }
              }
            }

            // For rotating-door models: re-attach logos to door pivot so they follow
            // door animation. S200H (doorLogoLeftUsesRight) handles its own attach above.
            if (!hasDoubleDoor && !activeBuildParams.doorLogoLeftUsesRight) {
              const doorPivNode = model?.getObjectByName('door');
              if (doorPivNode && doorPivNode !== model) {
                model.updateWorldMatrix(true, true);
                [leftLogo, rightLogo].forEach(logo => {
                  if (!logo) return;
                  if (logo.parent !== doorPivNode) {
                    doorPivNode.attach(logo);
                    logo.rotation.set(0, logo === leftLogo ? Math.PI : 0, 0);
                  }
                  logo.position.set(0, 0, 0);
                  logo.scale.set(1, 1, 1);
                  logo.userData.restPos = logo.position.clone();
                  logo.userData.restQuat = logo.quaternion.clone();
                  logo.userData.restScale = logo.scale.clone();
                });
              }
            }

            // Sync back door side if it is placed
            applyBackDoorSide(side);

            // Re-apply mosquito door orientation for every placed zone.
            // Always re-apply regardless of URL state — getPlacedAccessories() is authoritative.
            {
              const mosquitoItem = { key: 'mosquitoDoor' };
              const allPlacements = pergola.getPlacedAccessories?.() ?? [];
              allPlacements
                .filter(e => e.accessoryKey === 'mosquitoDoor')
                .forEach(e => pergola.applyAccessoryMeshVisibility(mosquitoItem, e.zone, e.spanIndex, true));

              // Fallback: if door_mosquito is visible but not in placements (e.g. placed via a
              // different code path), re-apply directly so the mesh always mirrors with the door.
              const mosquitoMesh = model?.getObjectByName('door_mosquito');
              const alreadyHandled = allPlacements.some(e => e.accessoryKey === 'mosquitoDoor' && e.zone === 'wallFront');
              if (mosquitoMesh?.visible && !alreadyHandled) {
                pergola.applyAccessoryMeshVisibility(mosquitoItem, 'wallFront', 0, true);
              }
            }

            requestRender();
          }
        }

        if (side === 'anim') {
          if (gltf && gltf.animations.length > 0) {
            const isOpen = doorAnimOpenState.get('mainDoor') ?? false;
            doorAnimOpenState.set('mainDoor', !isOpen);
            window._mainDoorIsOpen = !isOpen;
            $(this).find('img').attr('src', !isOpen
              ? 'public/img/icons/marevo-icon-door-animation-inactive.svg'
              : 'public/img/icons/marevo-icon-door-animation.svg');

            // Stop any previous door animation and create a fresh mixer each click —
            // same pattern as the mesh-click handler so no stale PropertyMixer bindings.
            if (doorMixer) doorMixer.stopAllAction();
            const freshMixer = new THREE.AnimationMixer(model);
            doorMixer = freshMixer;
            window._doorMixer = freshMixer;

            const logoNamesAnim = new Set(['door_mosquito_logo', 'door_logo', 'door_mosquito_back_logo', 'back_door_logo']);
            const propReAnim = /\.(position|quaternion|scale|morphTargetInfluences)$/;
            const stripLogos = clip => {
              const safeTracks = clip.tracks.filter(t => !logoNamesAnim.has(t.name.replace(propReAnim, '')));
              return safeTracks.length === clip.tracks.length
                ? clip : new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
            };

            const doorClips = gltf.animations
              .filter(a => ['doorAction', 'doorAction.003'].includes(a.name) ||
                a.tracks.some(t => { const n = t.name.replace(propReAnim, ''); return n === 'door' || n === 'front_wall'; }))
              .map(stripLogos)
              .filter(c => c.tracks.length > 0);
            if (!doorClips.length && gltf.animations[0]) doorClips.push(stripLogos(gltf.animations[0]));

            const actions = doorClips.map(clip => {
              const action = freshMixer.clipAction(clip);
              action.setLoop(THREE.LoopOnce, 1);
              action.clampWhenFinished = true;
              if (isOpen) {
                action.reset(); action.time = clip.duration; action.timeScale = -1;
              } else {
                action.reset(); action.timeScale = 1;
              }
              action.play();
              return action;
            });
            freshMixer.update(0.001);

            let lastTime = performance.now();
            const tick = () => {
              const now = performance.now();
              const delta = (now - lastTime) / 1000;
              freshMixer.update(delta);
              lastTime = now;
              requestRender();
              if (actions.some(a => a.isRunning())) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        }
      });

      // Restore the side that was active when the door was placed (or default to left)
      const initialSide = window._backDoorSide ?? 'left';
      portalContent.find(initialSide === 'right' ? '.portal-door-btn--right' : '.portal-door-btn--left').trigger('click');

      // Remove a specific placed door accessory (per-placement pair)
      // Card click → toggle selected state
      portalContent.on('click', '.portal-auto-vent-group__cards .portal-vent-action', function (e) {
        if ($(e.target).closest('.portal-vent-action__cancel').length) return;
        const activating = !$(this).hasClass('portal-vent-action--active');
        $(this).toggleClass('portal-vent-action--active');
        if (activating) showHotspotsForAccessory($(this).data('key'));
      });

      portalContent.on('click', '.portal-auto-vent-group__add-btn', function (e) {
        e.stopPropagation();
        showHotspotsForAccessory($(this).data('key'));
      });

      // Cancel click → remove placed door
      portalContent.on('click', '.portal-vent-action__cancel[data-action="removePlaced"]', function (e) {
        e.stopPropagation();
        const key = $(this).data('key');
        const zone = $(this).data('zone');
        const span = +$(this).data('span');
        removePlacedAccessory(key, zone, span);
        setTimeout(() => portalGenerete(), 50);
      });

      // + another placement for a door accessory
      portalContent.on('click', '.portal-vent-action[data-action="addDoor"]', function () {
        const key = $(this).data('key');
        const $mainCard = $(`.type_interface_accessories__card[data-key="${key}"]`);
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForAccessory(key);
        }
      });

      // Animation icon — play forward on first click, reverse on second click
      const DOOR_ANIM_NODES = {
        mosquitoDoor: ['door_mosquito', 'door_mosquito_back', 'door_mosquito001'],
        extraDoor: ['back_wall_door', 'back_wall_doors', 'back_door', 'side_door_L', 'side_door_R'],
        extraDoubleDoor: ['front_wall_double', 'back_wall_double', 'back_wall_double_door', 'side_door_double_L', 'side_door_double_R'],
      };
      const propRe10 = /\.(position|quaternion|scale|morphTargetInfluences)$/;

      const playNodeAnim10 = (animKey, onFinish) => {
        // Use the outer `gltf` / `model` from the portal closure — they correctly resolve
        // to the active model's GLTF. Re-declaring them with IMPORTED_MODELS_GLTF[0] would
        // always hit the first model and find meshes hidden in the wrong scene.
        if (!gltf || !model) return;
        const nodeNames = DOOR_ANIM_NODES[animKey] ?? [];
        if (!nodeNames.length) return;
        const subtreeNames = new Set();
        nodeNames.forEach(name => {
          const obj = model.getObjectByName(name);
          if (obj?.visible) obj.traverse(o => { if (o.name) subtreeNames.add(o.name); });
        });
        if (!subtreeNames.size) return;
        // On XH models back_door_logo is a SIBLING of back_door (not a child), so it has its own
        // animation tracks that must be played explicitly. On other models (e.g. R200H) it is a
        // CHILD of back_door and follows the door naturally — playing its tracks separately causes
        // double-animation and a Y-axis position jump.
        const XH_ANIM_CODES = new Set(['R306XH', 'R308XH']);
        const isXHModel = XH_ANIM_CODES.has(getCurrentSizeCode());
        if (animKey === 'extraDoor' && isXHModel) {
          const bdLogo = model.getObjectByName('back_door_logo');
          if (bdLogo?.visible) bdLogo.traverse(o => { if (o.name) subtreeNames.add(o.name); });
        }
        const clips = gltf.animations.filter(a =>
          a.tracks.some(t => subtreeNames.has(t.name.replace(propRe10, '')))
        );
        if (!clips.length) return;
        const isOpen = doorAnimOpenState.get(animKey) ?? false;
        doorAnimOpenState.set(animKey, !isOpen);
        const logoNames10 = new Set(['door_mosquito_logo', 'door_logo', 'door_mosquito_back_logo', 'back_door_logo', 'door1_F_logo', 'door2_F_logo', 'door1_F_back_logo', 'door2_F_back_logo', 'door_logo_L', 'door_mosquito_logo_L', 'door_logo_R', 'door_mosquito_logo_R', 'door_1_double_logo', 'door_2_double_logo', 'door_1_back_logo', 'door_2_back_logo', 'door_1_double_logo_L', 'door_2_double_logo_L', 'door_1_double_logo_R', 'door_2_double_logo_R']);
        // Also suppress Blender-instanced logo name variants (e.g. door_logo001 for S100H)
        // Three.js strips the dot from Blender's .001 suffix → "door_logo001" not "door_logo.001"
        for (const n of subtreeNames) {
          if (/^(door_logo|door_mosquito_logo)\d+$/.test(n)) logoNames10.add(n);
        }
        // back_door_logo on XH models is a sibling of back_door — needs its own tracks played directly.
        // door_logo001 on S100H is a sibling of door001 (inside back_wall_doors) — same pattern.
        const logoSiblingOverrides = new Set();
        if (animKey === 'extraDoor') {
          if (isXHModel) logoSiblingOverrides.add('back_door_logo');
          if (model.getObjectByName('back_wall_doors')) logoSiblingOverrides.add('door_logo001');
        }
        const safeClips10 = clips.map(clip => {
          const safeTracks = clip.tracks.filter(t => {
            const n = t.name.replace(propRe10, '');
            return subtreeNames.has(n) && (!logoNames10.has(n) || logoSiblingOverrides.has(n));
          });
          return new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
        }).filter(clip => clip.tracks.length > 0);
        const animMixer = new THREE.AnimationMixer(model);
        safeClips10.forEach(clip => {
          const action = animMixer.clipAction(clip);
          action.setLoop(THREE.LoopOnce, 1);
          action.clampWhenFinished = true;
          if (isOpen) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
          else { action.reset(); action.timeScale = 1; }
          action.play();
        });
        animMixer.update(0.001);

        // extraDoubleDoor (logos are siblings (not children) of panels, so they don't follow automatically)
        const doubleDoorLogoSync10 = (() => {
          if (animKey !== 'extraDoubleDoor') return [];
          const dblLogoSet = new Set(['door1_F_logo', 'door2_F_logo', 'door1_F_back_logo', 'door2_F_back_logo']);
          const results = [];
          ['front_wall_double', 'back_wall_double'].forEach(groupName => {
            const group = model.getObjectByName(groupName);
            if (!group?.visible) return;
            const groupSubtree = new Set();
            group.traverse(o => { if (o.name) groupSubtree.add(o.name); });
            gltf.animations.forEach(clip => {
              clip.tracks.filter(t => /\.scale$/.test(t.name)).forEach(t => {
                const panelName = t.name.replace(/\.scale$/, '');
                if (!groupSubtree.has(panelName) || dblLogoSet.has(panelName)) return;
                const panel = model.getObjectByName(panelName);
                const logo = model.getObjectByName(panelName + '_logo');
                if (panel && logo?.visible && !results.some(r => r.panel === panel)) {
                  results.push({ logo, panel });
                }
              });
            });
          });
          return results;
        })();

        let lastTime = performance.now();
        const tick = () => {
          const now = performance.now();
          animMixer.update((now - lastTime) / 1000);
          lastTime = now;
          doubleDoorLogoSync10.forEach(({ logo, panel }) => logo.scale.copy(panel.scale));
          requestRender();
          if (animMixer._actions.some(a => a.isRunning())) {
            requestAnimationFrame(tick);
          } else if (onFinish) {
            onFinish();
          }
        };
        requestAnimationFrame(tick);
      };

      const animateMosquitoDoor = () => {
        if (!gltf || !model) return;

        // Sync legacy front-door flag into per-root flags so checks below are consistent
        if ((doorAnimOpenState.get('mainDoor') ?? false) || (window._mainDoorIsOpen ?? false)) {
          window._doorOpen_front_wall = true;
          window._doorOpen_front_wall_double = true;
        }

        const logoNamesPre = new Set(['door_mosquito_logo', 'door_logo', 'door_mosquito_back_logo', 'back_door_logo']);

        // All mosquito subtree names (exclude from parent door clips)
        const mosqNamesForFilter = new Set();
        ['door_mosquito', 'door_mosquito_back', 'door_mosquito001'].forEach(n => {
          const obj = model.getObjectByName(n);
          if (obj) obj.traverse(o => { if (o.name) mosqNamesForFilter.add(o.name); });
        });

        const doorCandidateNames = ['front_wall', 'back_wall_door', 'back_wall_doors', 'front_wall_double', 'back_wall_double'];
        const animatedNames = new Set();
        gltf.animations.forEach(clip => clip.tracks.forEach(t => animatedNames.add(t.name.replace(propRe10, ''))));

        const visibleMosqRoots = ['door_mosquito', 'door_mosquito_back', 'door_mosquito001']
          .map(n => model.getObjectByName(n))
          .filter(obj => obj?.visible);

        // Build parent door entry for each visible mosquito root
        const collectParentDoors = (filterOpen) => {
          const result = new Map();
          for (const mosqRoot of visibleMosqRoots) {
            let parentDoorRoot = null;
            for (const cname of doorCandidateNames) {
              const obj = model.getObjectByName(cname);
              if (!obj || !obj.visible) continue;
              let found = false;
              obj.traverse(o => { if (o === mosqRoot || o === mosqRoot.parent) found = true; });
              if (found) { parentDoorRoot = obj; break; }
            }
            if (!parentDoorRoot) {
              let cur = mosqRoot.parent;
              while (cur && cur !== model) {
                if (animatedNames.has(cur.name) && cur.visible) { parentDoorRoot = cur; break; }
                cur = cur.parent;
              }
            }
            if (!parentDoorRoot) continue;
            const openKey = `_doorOpen_${parentDoorRoot.name}`;
            const isOpen = !!window[openKey];
            if (isOpen !== filterOpen) continue; // only collect matching state
            if (result.has(parentDoorRoot.name)) continue;
            const parentSubtree = new Set();
            parentDoorRoot.traverse(o => { if (o.name) parentSubtree.add(o.name); });
            const clips = gltf.animations
              .filter(a => a.tracks.some(t => parentSubtree.has(t.name.replace(propRe10, ''))))
              .map(clip => {
                const safeTracks = clip.tracks.filter(t => {
                  const n = t.name.replace(propRe10, '');
                  return !logoNamesPre.has(n) && !mosqNamesForFilter.has(n);
                });
                return safeTracks.length === clip.tracks.length
                  ? clip : new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
              }).filter(clip => clip.tracks.length > 0);
            if (clips.length) result.set(parentDoorRoot.name, { openKey, rootName: parentDoorRoot.name, clips });
          }
          return result;
        };

        // Play a set of parent door clips (forward or reverse), call onDone when all finish
        const playParentDoors = (doorsMap, reverse, onDone) => {
          if (doorsMap.size === 0) { onDone(); return; }
          let done = 0;
          for (const { openKey, rootName, clips } of doorsMap.values()) {
            window[openKey] = !reverse;
            if (rootName === 'front_wall' || rootName === 'front_wall_double') {
              doorAnimOpenState.set('mainDoor', !reverse);
              window._mainDoorIsOpen = !reverse;
            }
            const preMixer = new THREE.AnimationMixer(model);
            clips.forEach(clip => {
              const action = preMixer.clipAction(clip);
              action.setLoop(THREE.LoopOnce, 1);
              action.clampWhenFinished = true;
              if (reverse) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
              else { action.reset(); action.timeScale = 1; }
              action.play();
            });
            preMixer.update(0.001);
            let lastTime = performance.now();
            const tick = () => {
              const now = performance.now();
              preMixer.update((now - lastTime) / 1000);
              lastTime = now;
              requestRender();
              if (preMixer._actions?.some(a => a.isRunning())) requestAnimationFrame(tick);
              else { done++; if (done >= doorsMap.size) onDone(); }
            };
            requestAnimationFrame(tick);
          }
        };

        const mosquitoIsOpen = doorAnimOpenState.get('mosquitoDoor') ?? false;

        if (mosquitoIsOpen) {
          // CLOSING: mosquito first, then parent door in reverse.
          // Build mosquito-close clips manually so parent-door node names are explicitly excluded
          // (a shared GLTF clip can target both; generic playNodeAnim10 doesn't know to exclude them)
          const doorsToClose = collectParentDoors(true);
          const mosqCloseSubtree = new Set();
          ['door_mosquito', 'door_mosquito_back', 'door_mosquito001'].forEach(n => {
            const obj = model.getObjectByName(n);
            if (obj?.visible) obj.traverse(o => { if (o.name) mosqCloseSubtree.add(o.name); });
          });
          // Exclude parent-door-only nodes from mosquito clips.
          // door_mosquito is a child of front_wall, so the door subtree includes mosquito names —
          // remove them from the exclusion set so mosquito tracks are not filtered out.
          const parentDoorExcludeNames = new Set();
          for (const { rootName } of doorsToClose.values()) {
            const root = model.getObjectByName(rootName);
            if (root) root.traverse(o => { if (o.name) parentDoorExcludeNames.add(o.name); });
          }
          for (const n of mosqCloseSubtree) parentDoorExcludeNames.delete(n);
          const mosqCloseClips = gltf.animations
            .filter(a => a.tracks.some(t => mosqCloseSubtree.has(t.name.replace(propRe10, ''))))
            .map(clip => {
              const safeTracks = clip.tracks.filter(t => {
                const n = t.name.replace(propRe10, '');
                return mosqCloseSubtree.has(n) && !logoNamesPre.has(n) && !parentDoorExcludeNames.has(n);
              });
              return new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
            }).filter(clip => clip.tracks.length > 0);

          doorAnimOpenState.set('mosquitoDoor', false);

          if (!mosqCloseClips.length) {
            playParentDoors(doorsToClose, true, () => { });
            return;
          }

          const mosqCloseMixer = new THREE.AnimationMixer(model);
          let mosqDoneCount = 0;
          let mosqAllDone = false;
          mosqCloseMixer.addEventListener('finished', () => {
            mosqDoneCount++;
            if (mosqDoneCount >= mosqCloseClips.length) mosqAllDone = true;
          });
          mosqCloseClips.forEach(clip => {
            const action = mosqCloseMixer.clipAction(clip);
            action.setLoop(THREE.LoopOnce, 1);
            action.clampWhenFinished = true;
            action.reset(); action.time = clip.duration; action.timeScale = -1;
            action.play();
          });
          mosqCloseMixer.update(0.001);
          let mosqLastTime = performance.now();
          const mosqTick = () => {
            const now = performance.now();
            mosqCloseMixer.update((now - mosqLastTime) / 1000);
            mosqLastTime = now;
            requestRender();
            if (!mosqAllDone) requestAnimationFrame(mosqTick);
            else playParentDoors(doorsToClose, true, () => { });
          };
          requestAnimationFrame(mosqTick);
        } else {
          // OPENING: parent door first, then mosquito door
          const doorsToOpen = collectParentDoors(false); // doors that are currently closed
          playParentDoors(doorsToOpen, false, () => playNodeAnim10('mosquitoDoor', null));
        }
      };

      portalContent.on('click', '.portal-auto-vent-group__icon[data-animkey]', function () {
        const key = $(this).data('animkey');
        const $icon = $(this);
        const wasOpen = doorAnimOpenState.get(key) ?? false;
        if (key === 'mosquitoDoor') {
          animateMosquitoDoor();
        } else {
          playNodeAnim10(key, null);
        }
        $icon.attr('src', !wasOpen
          ? 'public/img/icons/marevo-icon-door-animation-inactive.svg'
          : 'public/img/icons/marevo-icon-door-animation.svg');
      });

      // Also handle mosquito door click on 3D scene
      const onMosquitoDoorSceneClick = () => animateMosquitoDoor();
      window.addEventListener('mosquitoDoorSceneClick', onMosquitoDoorSceneClick);

      // Re-render portal when an accessory is placed/removed (keeps pairs in sync)
      const onAccessoryPlaced10 = (e) => {
        if (state.portalOption === 10) {
          if (e?.detail?.key) window._ventFlashKey = e.detail.key;
          setTimeout(() => portalGenerete(), 50);
        }
      };
      window.addEventListener('accessoryPlaced', onAccessoryPlaced10);
      portalContent.on('remove', () => {
        window.removeEventListener('accessoryPlaced', onAccessoryPlaced10);
        window.removeEventListener('mosquitoDoorSceneClick', onMosquitoDoorSceneClick);
      });
    }
    //#endregion

    //#region VENTILATION POPUP (case 11)
    if (state.portalOption === 11) {
      const gltf = IMPORTED_MODELS_GLTF.find(g => g?.scene === theModel) ?? IMPORTED_MODELS_GLTF[0];
      const roofWinMixers = [];
      window._roofWinMixers = roofWinMixers;

      // 1 - dissable removing automated opening
      portalContent.on('click', '.portal-vent-action[data-action="removeAuto"]:not(.portal-vent-action--disabled)', function () {
        const $mainCard = $('.type_interface_accessories__card[data-key="automateOpening"]');
        if ($mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        }
        $(this).addClass('portal-vent-action--disabled');
        portalContent.find('.portal-auto-vent-group__icon[data-animkey="automateOpening"]').addClass('disabled');
      });

      // 2 — Add automated opening
      portalContent.on('click', '.portal-vent-action[data-action="addAuto"]', function () {
        showHotspotsForAutomatedOpening();
        portalContent.find('.portal-vent-action[data-action="removeAuto"]').removeClass('portal-vent-action--disabled');
        portalContent.find('.portal-auto-vent-group__icon[data-animkey="automateOpening"]').removeClass('disabled');
      });

      // 3 — Play animation 
      portalContent.on('click', '.portal-vent-action[data-action="animateWindow"]', function () {
        if (!gltf?.animations?.length) return;

        const clones = getPlacedAutoWindowClones();
        if (!clones.length) return;

        roofWinMixers.length = 0;
        const actions = [];

        const propRe = /\.(position|quaternion|scale|morphTargetInfluences)$/;

        clones.forEach(clone => {
          const origTemplate = gltf.scene.getObjectByName(clone.name);
          if (!origTemplate) return;

          // Build: original object name → clone child UUID
          const nameToUUID = new Map();
          nameToUUID.set(clone.name, clone.uuid);
          clone.traverse(o => { if (o.name) nameToUUID.set(o.name, o.uuid); });

          const descendantNames = new Set([origTemplate.name]);
          origTemplate.traverse(o => { if (o.name) descendantNames.add(o.name); });

          // filter clips that target any object in this subtree
          const relevantClips = gltf.animations.filter(a =>
            a.tracks.some(t => {
              const prop = t.name.match(propRe)?.[0] ?? '';
              const objName = t.name.slice(0, t.name.length - prop.length);
              return descendantNames.has(objName);
            })
          );

          if (!relevantClips.length) return;

          const mixer = new THREE.AnimationMixer(clone);
          roofWinMixers.push(mixer);

          relevantClips.forEach(origClip => {
            const retargetedTracks = origClip.tracks.map(t => {
              const prop = t.name.match(propRe)?.[0] ?? '';
              const objName = t.name.slice(0, t.name.length - prop.length);
              const uuid = nameToUUID.get(objName);
              const newName = uuid ? (uuid + prop) : t.name;
              return Object.assign(t.clone(), { name: newName });
            });

            const clip = new THREE.AnimationClip(origClip.name, origClip.duration, retargetedTracks);
            const action = mixer.clipAction(clip);
            action.setLoop(THREE.LoopOnce, 1);
            action.clampWhenFinished = true;
            action.reset().play();
            mixer.update(0.001);
            actions.push({ action });
          });
        });

        window._roofWinMixers = roofWinMixers;

        let lastTime = performance.now();
        const tick = () => {
          const now = performance.now();
          const delta = (now - lastTime) / 1000;
          lastTime = now;
          roofWinMixers.forEach(m => m.update(delta));
          requestRender();
          if (actions.some(({ action }) => action.isRunning())) {
            requestAnimationFrame(tick);
          }
        };
        requestAnimationFrame(tick);
      });

      // Remove a specific placed roof/side window (per-placement pair)
      // Card click → toggle selected state
      portalContent.on('click', '.portal-auto-vent-group__cards .portal-vent-action', function (e) {
        if ($(e.target).closest('.portal-vent-action__cancel').length) return;
        const activating = !$(this).hasClass('portal-vent-action--active');
        $(this).toggleClass('portal-vent-action--active');
        if (activating) showHotspotsForAccessory($(this).data('key'));
      });

      portalContent.on('click', '.portal-auto-vent-group__add-btn', function (e) {
        e.stopPropagation();
        showHotspotsForAccessory($(this).data('key'));
      });

      // Cancel click → remove placed window
      portalContent.on('click', '.portal-vent-action__cancel[data-action="removePlaced11"]', function (e) {
        e.stopPropagation();
        const key = $(this).data('key');
        const zone = $(this).data('zone');
        const span = +$(this).data('span');
        if (key === 'roofWindow') {
          const autoEntry = pergola.getPlacedAccessories().find(
            p => p.accessoryKey === 'automateOpening' && p.zone === zone && p.spanIndex === span
          );
          if (autoEntry) removePlacedAccessory('automateOpening', zone, span);
        }
        removePlacedAccessory(key, zone, span);
        setTimeout(() => portalGenerete(), 50);
      });

      // + another roof window
      portalContent.on('click', '.portal-vent-action[data-action="addRoofWin"]', function () {
        const $mainCard = $('.type_interface_accessories__card[data-key="roofWindow"]');
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForAccessory('roofWindow');
        }
      });

      // + another side window
      portalContent.on('click', '.portal-vent-action[data-action="addSideWin"]', function () {
        const $mainCard = $('.type_interface_accessories__card[data-key="sideWindow"]');
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForAccessory('sideWindow');
        }
      });

      // + back window
      portalContent.on('click', '.portal-vent-action[data-action="addBackWin"]', function () {
        const $mainCard = $('.type_interface_accessories__card[data-key="backWindow"]');
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForAccessory('backWindow');
        }
      });

      // Window mode toggle for sideWindow & backWindow
      const WINDOW_MODE_LABELS = {
        sideWindow: { 'manual-window': 'Manual Side Windows', 'auto-window': 'Automatic Side Windows' },
        backWindow: { 'manual-window': 'Manual Rear Window', 'auto-window': 'Automatic Rear Window' },
      };
      portalContent.on('click', '.toggle-switch[data-window-key]', function () {
        const winKey = $(this).data('window-key');
        const current = state.windowModes[winKey] || 'manual-window';
        const next = current === 'manual-window' ? 'auto-window' : 'manual-window';

        state.windowModes[winKey] = next;

        $(this).attr('data-option', next);
        $(this).find('.toggle-knob').toggleClass('toggle-knob--right', next === 'auto-window');

        $(this).siblings('.toggle-label[data-option="manual-window"]').toggleClass('active', next === 'manual-window');
        $(this).siblings('.toggle-label[data-option="auto-window"]').toggleClass('active', next === 'auto-window');

        const labelText = WINDOW_MODE_LABELS[winKey]?.[next] || '';
        $(this).closest('.sideWindow_control').find('.window-mode-label').text(labelText);

        const $summaryEl = $('.type_interface_summary');
        if ($summaryEl.length) {
          $summaryEl.replaceWith(buildSummaryContent());
        }
        window.dispatchEvent(new CustomEvent('windowModeChanged', { detail: { key: winKey, mode: next } }));
        refreshCartTotal();
      });

      // Animation icon — play forward on first click, reverse on second click
      // roofWindow uses named model nodes; sideWindow/backWindow use placed clones as mixer roots
      const VENT_ANIM_NODES = {};
      // Keys whose accessories are placed as clones — find by accTag prefix, root mixer at each clone
      const VENT_ANIM_CLONE_PREFIX = {
        roofWindow: 'roofWindow__',
        sideWindow: 'sideWindow__',
        backWindow: 'backWindow__',
        automateOpening: 'automateOpening__',
      };
      const ventAnimOpenState = new Map();
      const runClipOnRoot11 = (gltf11, root, isOpen11) => {
        const propRe11 = /\.(position|quaternion|scale|morphTargetInfluences)$/;
        const subtreeNames11 = new Set();
        root.traverse(o => { if (o.name) subtreeNames11.add(o.name); });
        const clips11 = gltf11.animations.filter(a =>
          a.tracks.some(t => subtreeNames11.has(t.name.replace(propRe11, '')))
        );
        if (!clips11.length) return;
        const animMixer11 = new THREE.AnimationMixer(root);
        clips11.forEach(clip => {
          const action = animMixer11.clipAction(clip);
          action.setLoop(THREE.LoopOnce, 1);
          action.clampWhenFinished = true;
          if (isOpen11) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
          else { action.reset(); action.timeScale = 1; }
          action.play();
        });
        animMixer11.update(0.001);
        let lastTime11 = performance.now();
        const tick11 = () => {
          const now = performance.now();
          animMixer11.update((now - lastTime11) / 1000);
          lastTime11 = now;
          requestRender();
          if (animMixer11._actions.some(a => a.isRunning())) requestAnimationFrame(tick11);
        };
        requestAnimationFrame(tick11);
      };
      portalContent.on('click', '.portal-auto-vent-group__icon[data-animkey]', function () {
        const key = $(this).data('animkey');
        const $icon11 = $(this);
        const gltf11 = IMPORTED_MODELS_GLTF.find(g => g?.scene === theModel) ?? IMPORTED_MODELS_GLTF[0];
        const model11 = gltf11?.scene;
        if (!gltf11 || !model11) return;
        const propRe11 = /\.(position|quaternion|scale|morphTargetInfluences)$/;
        const clonePrefix = VENT_ANIM_CLONE_PREFIX[key];
        const R300_CODES = new Set(['R305H', 'R306H', 'R308H']);
        const isR300BackWin = key === 'backWindow' && R300_CODES.has(getCurrentSizeCode());
        const updateIcon11 = (wasOpen11) => {
          $icon11.attr('src', !wasOpen11
            ? 'public/img/icons/marevo-icon-door-animation-inactive.svg'
            : 'public/img/icons/marevo-icon-door-animation.svg');
        };
        if (isR300BackWin) {
          // R300 uses original model meshes, not clones — animate visible back_w_L_G / back_w_R_G
          const r300BackMeshNames = ['back_w_L_G', 'back_w_R_G'];
          const visibleRoots = r300BackMeshNames
            .map(n => model11.getObjectByName(n))
            .filter(o => o?.visible);
          if (!visibleRoots.length) return;
          const isOpen11 = ventAnimOpenState.get(key) ?? false;
          ventAnimOpenState.set(key, !isOpen11);
          visibleRoots.forEach(root => runClipOnRoot11(gltf11, root, isOpen11));
          updateIcon11(isOpen11);
          return;
        }
        if (clonePrefix) {
          // Find all placed clones for this key and animate each one independently
          const clones11 = [];
          model11.traverse(o => { if (o.userData?.accTag?.startsWith(clonePrefix)) clones11.push(o); });
          if (!clones11.length) return;
          const isOpen11 = ventAnimOpenState.get(key) ?? false;
          ventAnimOpenState.set(key, !isOpen11);
          clones11.forEach(root => runClipOnRoot11(gltf11, root, isOpen11));
          updateIcon11(isOpen11);
        } else {
          // Node-based: find named objects in model11 and use model11 as mixer root
          const nodeNames11 = VENT_ANIM_NODES[key] ?? [];
          if (!nodeNames11.length) return;
          const subtreeNames11 = new Set();
          nodeNames11.forEach(name => {
            const obj = model11.getObjectByName(name);
            if (obj?.visible) obj.traverse(o => { if (o.name) subtreeNames11.add(o.name); });
          });
          if (!subtreeNames11.size) return;
          const clips11 = gltf11.animations.filter(a =>
            a.tracks.some(t => subtreeNames11.has(t.name.replace(propRe11, '')))
          );
          if (!clips11.length) return;
          const isOpen11 = ventAnimOpenState.get(key) ?? false;
          ventAnimOpenState.set(key, !isOpen11);
          updateIcon11(isOpen11);
          const animMixer11 = new THREE.AnimationMixer(model11);
          clips11.forEach(clip => {
            const action = animMixer11.clipAction(clip);
            action.setLoop(THREE.LoopOnce, 1);
            action.clampWhenFinished = true;
            if (isOpen11) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
            else { action.reset(); action.timeScale = 1; }
            action.play();
          });
          animMixer11.update(0.001);
          let lastTime11 = performance.now();
          const tick11 = () => {
            const now = performance.now();
            animMixer11.update((now - lastTime11) / 1000);
            lastTime11 = now;
            requestRender();
            if (animMixer11._actions.some(a => a.isRunning())) requestAnimationFrame(tick11);
          };
          requestAnimationFrame(tick11);
        }
      });

      // Re-render portal when an accessory is placed/removed (keeps pairs in sync)
      const onAccessoryPlaced11 = (e) => {
        if (state.portalOption === 11) {
          if (e?.detail?.key) window._ventFlashKey = e.detail.key;
          setTimeout(() => portalGenerete(), 50);
        }
      };
      window.addEventListener('accessoryPlaced', onAccessoryPlaced11);
      portalContent.on('remove', () => window.removeEventListener('accessoryPlaced', onAccessoryPlaced11));
    }
    //#endregion

    //#region ORGANIZATION POPUP (case 12)
    if (state.portalOption === 12) {
      // Card click → toggle selected state (shows/hides cancel button)
      portalContent.on('click', '.portal-auto-vent-group__cards .portal-vent-action', function (e) {
        if ($(e.target).closest('.portal-vent-action__cancel').length) return;
        const activating = !$(this).hasClass('portal-vent-action--active');
        $(this).toggleClass('portal-vent-action--active');
        if (activating) showHotspotsForAccessory($(this).data('key'));
      });

      portalContent.on('click', '.portal-auto-vent-group__add-btn', function (e) {
        e.stopPropagation();
        showHotspotsForAccessory($(this).data('key'));
      });

      // Cancel button click → remove the placed accessory
      portalContent.on('click', '.portal-vent-action__cancel[data-action="removeOrgPlaced"]', function (e) {
        e.stopPropagation();
        const key = $(this).data('key');
        const zone = $(this).data('zone');
        const span = +$(this).data('span');
        removePlacedAccessory(key, zone, span);
        setTimeout(() => portalGenerete(), 50);
      });

      // Re-render portal when an accessory is placed/removed (keeps cards in sync)
      const onAccessoryPlaced12 = (e) => {
        if (state.portalOption === 12) {
          if (e?.detail?.key) window._ventFlashKey = e.detail.key;
          setTimeout(() => portalGenerete(), 50);
        }
      };
      window.addEventListener('accessoryPlaced', onAccessoryPlaced12);
      portalContent.on('remove', () => window.removeEventListener('accessoryPlaced', onAccessoryPlaced12));
    }
    //#endregion

    //#region OTHERS POPUP (case 13)
    if (state.portalOption === 13) {
      // Collapse / expand sections
      portalContent.on('click', '.portal-other-group__header', function () {
        const group = $(this).data('group');
        const $body = $(this).siblings('.portal-other-group__body');
        const $arrow = $(this).find('.portal-auto-others-group__arrow');
        const isOpen = $body.is(':visible');
        // $body.toggle(!isOpen);
        $arrow.html(isOpen ? '&#9654;' : '&#9654;');
      });

      // Remove a placed "other" accessory
      // Card click -> toggle selected state
      portalContent.on('click', '.portal-auto-others-group__cards .portal-vent-action', function (e) {
        if ($(e.target).closest('.portal-vent-action__cancel').length) return;
        $(this).toggleClass('portal-vent-action--active');
      });

      // Cancel click → remove placed other accessory (downpipes are permanent, skip them)
      portalContent.on('click', '.portal-vent-action__cancel[data-action="removeOtherPlaced"]', function (e) {
        e.stopPropagation();
        const key = $(this).data('key');
        if (key === 'downpipes') return;
        const zone = $(this).data('zone');
        const span = +$(this).data('span');

        if (key === 'veil' && veilFoldIsOpen) {
          veilFoldClones.forEach(({ clone, parent }) => parent?.remove(clone));
          veilFoldClones = [];
          veilHiddenRoots.forEach(o => {
            o.visible = true;
            o.traverse(c => {
              c.visible = true;
              if (c.isMesh && c.material) {
                (Array.isArray(c.material) ? c.material : [c.material])
                  .forEach(m => { if (m.transparent) m.opacity = VEIL_OPACITY; });
              }
            });
          });
          veilHiddenRoots = [];
          veilFoldIsOpen = false;
        }

        removePlacedAccessory(key, zone, span);
        setTimeout(() => portalGenerete(), 50);
      });

      // Add veil / roofDecor (whole-model, no hotspot)
      portalContent.on('click', '.portal-vent-action[data-action="addOtherSimple"]', function () {
        const key = $(this).data('key');
        const $mainCard = $(`.type_interface_accessories__card[data-key="${key}"]`);
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForAccessory(key);
        }
      });

      // Add downpipes — trigger hotspot selection
      portalContent.on('click', '.portal-vent-action[data-action="addDownpipes"]', function () {
        const $mainCard = $(`.type_interface_accessories__card[data-key="downpipes"]`);
        if (!$mainCard.hasClass('type_interface_accessories__card--selected')) {
          $mainCard.trigger('click');
        } else {
          showHotspotsForDownpipes();
        }
      });

      // Downpipes: position button (front wall / back wall) — radio-style, never removes all
      portalContent.on('click', '.portal-downpipes-pos-btn', function () {
        const zone = $(this).data('dp-zone');
        const otherZone = zone === 'wallFront' ? 'wallBack' : 'wallFront';
        const alreadyInZone = pergola.getPlacedAccessories().some(
          p => p.accessoryKey === 'downpipes' && p.zone === zone
        );
        if (alreadyInZone) return;
        dpToggling = true;
        pergola.placeAccessory('downpipes', zone, 0);
        state.subAccessoriesUrl.add('downpipes');
        removePlacedAccessory('downpipes', otherZone, 0);
        state.subAccessoriesUrl.add('downpipes');
        dpToggling = false;
        setTimeout(() => portalGenerete(), 50);
      });

      // Downpipes: position toggle
      portalContent.on('change', '#dp-both-toggle', function () {
        const checked = $(this).is(':checked');
        dpToggling = true;
        const placed = pergola.getPlacedAccessories();
        if (checked) {
          // back wall: only place if not already placed (placeAccessory toggles off when already placed)
          const backAlreadyPlaced = placed.some(p => p.accessoryKey === 'downpipes' && p.zone === 'wallBack');
          if (!backAlreadyPlaced) pergola.placeAccessory('downpipes', 'wallBack', 0);
          state.subAccessoriesUrl.add('downpipes');
          removePlacedAccessory('downpipes', 'wallFront', 0);
        } else {
          // front wall: only place if not already placed
          const frontAlreadyPlaced = placed.some(p => p.accessoryKey === 'downpipes' && p.zone === 'wallFront');
          if (!frontAlreadyPlaced) pergola.placeAccessory('downpipes', 'wallFront', 0);
          state.subAccessoriesUrl.add('downpipes');
          removePlacedAccessory('downpipes', 'wallBack', 0);
        }
        // Re-add after removal in case removePlacedAccessory deleted it from subAccessoriesUrl
        state.subAccessoriesUrl.add('downpipes');
        dpToggling = false;

        portalContent.find('.portal-downpipes-pos-btn[data-dp-zone="wallFront"]')
          .toggleClass('portal-downpipes-pos-btn--active', !checked);
        portalContent.find('.portal-downpipes-pos-btn[data-dp-zone="wallBack"]')
          .toggleClass('portal-downpipes-pos-btn--active', checked);
      });

      // Downpipes: material selection
      portalContent.on('click', '.portal-downpipes-mat', function () {
        const mat = $(this).data('dp-mat');
        state.downpipeMaterial = mat;
        // Re-apply all placed downpipes with new material
        const placed = pergola.getPlacedAccessories().filter(p => p.accessoryKey === 'downpipes');
        placed.forEach(p => {
          pergola.applyAccessoryMeshVisibility(p.item, p.zone, p.spanIndex, true);
        });
        setTimeout(() => portalGenerete(), 50);
      });

      // Veil fold animation
      const fadeVeil = (roots, fadeIn, duration, onDone) => {
        const allMats = [];
        roots.forEach(root => {
          root.traverse(c => {
            if (!c.isMesh || !c.material) return;
            (Array.isArray(c.material) ? c.material : [c.material]).forEach(m => {
              if (m.transparent) allMats.push(m);
            });
          });
        });
        if (!allMats.length) { if (onDone) onDone(); return; }
        if (fadeIn) allMats.forEach(m => { m.opacity = 0; });
        const startOp = fadeIn ? 0 : VEIL_OPACITY;
        const endOp = fadeIn ? VEIL_OPACITY : 0;
        const start = performance.now();
        const tick = () => {
          const t = Math.min((performance.now() - start) / duration, 1);
          const e = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          allMats.forEach(m => { m.opacity = startOp + (endOp - startOp) * e; });
          requestRender();
          if (t < 1) requestAnimationFrame(tick);
          else if (onDone) onDone();
        };
        requestAnimationFrame(tick);
      };

      portalContent.on('click', '.portal-auto-vent-group__icon[data-animkey="veil"]', function (e) {
        e.stopPropagation();
        const $icon = $(this);
        const model = theModel;
        if (!model) return;

        if (!veilFoldIsOpen) {
          const veilNames = new Set(['shade_veil_front', 'shade_veil_back', 'shade_veil_center']);
          veilHiddenRoots = [];
          model.traverse(o => { if (veilNames.has(o.name) && o.visible) veilHiddenRoots.push(o); });

          const frontMesh = model.getObjectByName('shade_veil_front');
          const backMesh = model.getObjectByName('shade_veil_back');
          if (!frontMesh || !backMesh) return;

          // Fade out originals then hide
          fadeVeil(veilHiddenRoots, false, 800, () => {
            veilHiddenRoots.forEach(o => { o.visible = false; o.traverse(c => { c.visible = false; }); });
          });

          veilFoldLoader.load(VEIL_FOLD_GLB, (gltf) => {
            const source = gltf.scene.getObjectByName('shade_veil_center001');
            if (!source) { console.warn('[veil fold] shade_veil_center001 not found in GLB'); return; }

            // step size from consecutive shade_veil_center positions
            const centerObjs = [];
            model.traverse(o => { if (o.name === 'shade_veil_center') centerObjs.push(o); });
            centerObjs.sort((a, b) => a.position.z - b.position.z);
            const stepSize = centerObjs.length > 1 ? centerObjs[1].position.z - centerObjs[0].position.z : 0;

            // parent-local bbox center z for a mesh (handles geometry pivot offset)
            const bboxCenterLocalZ = (mesh) => {
              const box = new THREE.Box3().setFromObject(mesh);
              const center = box.getCenter(new THREE.Vector3());
              mesh.parent.worldToLocal(center);
              return center.z;
            };

            veilFoldClones = [];
            const placements = [
              { mesh: frontMesh, z: frontMesh.position.z + stepSize * 0.5 },
              { mesh: backMesh, z: bboxCenterLocalZ(backMesh) + stepSize },
            ];
            placements.forEach(({ mesh, z }) => {
              if (!mesh.parent) return;
              const copy = source.clone(true);
              copy.position.copy(mesh.position);
              copy.position.z = z;
              copy.rotation.copy(mesh.rotation);
              copy.scale.copy(mesh.scale);
              copy.visible = true;
              copy.traverse(c => {
                c.visible = true;
                if (c.isMesh && c.material) {
                  const arr = Array.isArray(c.material) ? c.material : [c.material];
                  const cloned = arr.map(m => { const n = m.clone(); n.transparent = true; n.opacity = 0; n.depthWrite = false; return n; });
                  c.material = Array.isArray(c.material) ? cloned : cloned[0];
                }
              });
              mesh.parent.add(copy);
              veilFoldClones.push({ clone: copy, parent: mesh.parent });
            });

            // Fade in clones after originals have started fading
            setTimeout(() => fadeVeil(veilFoldClones.map(x => x.clone), true, 900, null), 400);
            requestRender();
          }, undefined, (err) => console.error('[veil fold] GLB load error:', err));

          veilFoldIsOpen = true;
          $icon.attr('src', 'public/img/icons/marevo-icon-door-animation-inactive.svg');

        } else {
          // Fade out fold clones, then remove them and restore originals
          const clones = veilFoldClones.map(x => x.clone);
          fadeVeil(clones, false, 800, () => {
            veilFoldClones.forEach(({ clone, parent }) => parent.remove(clone));
            veilFoldClones = [];
          });

          const toRestore = veilHiddenRoots;
          toRestore.forEach(o => { o.visible = true; o.traverse(c => { c.visible = true; }); });
          setTimeout(() => fadeVeil(toRestore, true, 900, null), 400);

          veilFoldIsOpen = false;
          veilHiddenRoots = [];
          $icon.attr('src', 'public/img/icons/marevo-icon-door-animation.svg');
        }
      });

      // Re-render portal when an accessory is placed/removed (keeps cards in sync)
      const onAccessoryPlaced13 = (e) => {
        if (state.portalOption !== 13 || dpToggling) return;
        if (veilFoldIsOpen && !pergola.getPlacedAccessories().some(p => p.accessoryKey === 'veil')) {
          veilFoldClones.forEach(({ clone, parent }) => parent?.remove(clone));
          veilFoldClones = [];
          veilHiddenRoots.forEach(o => {
            o.traverse(c => {
              if (c.isMesh && c.material) {
                (Array.isArray(c.material) ? c.material : [c.material])
                  .forEach(m => { if (m.transparent) m.opacity = VEIL_OPACITY; });
              }
            });
          });
          veilHiddenRoots = [];
          veilFoldIsOpen = false;
        }
        if (e?.detail?.key) window._ventFlashKey = e.detail.key;
        setTimeout(() => portalGenerete(), 50);
      };
      window.addEventListener('accessoryPlaced', onAccessoryPlaced13);
      portalContent.on('remove', () => {
        window.removeEventListener('accessoryPlaced', onAccessoryPlaced13);
        if (veilFoldClones.length) {
          veilFoldClones.forEach(({ clone, parent }) => parent?.remove(clone));
          veilFoldClones = [];
        }
        if (veilHiddenRoots.length) {
          const veilStillPlaced = pergola.getPlacedAccessories().some(p => p.accessoryKey === 'veil');
          if (veilStillPlaced) {
            veilHiddenRoots.forEach(o => { o.visible = true; o.traverse(c => { c.visible = true; }); });
          } else {
            // reset opacity (fpr next add looks correct)
            veilHiddenRoots.forEach(o => {
              o.traverse(c => {
                if (c.isMesh && c.material) {
                  (Array.isArray(c.material) ? c.material : [c.material])
                    .forEach(m => { if (m.transparent) m.opacity = VEIL_OPACITY; });
                }
              });
            });
          }
          veilHiddenRoots = [];
        }
        veilFoldIsOpen = false;
      });
    }
    //#endregion

    mainContent.append(portalContent);

    // Flash a newly placed card if requested (set via window._ventFlashKey before calling portalGenerete)
    if (window._ventFlashKey) {
      const flashKey = window._ventFlashKey;
      window._ventFlashKey = null;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const $targets = portalContent.find(
          `.portal-auto-vent-group__cards .portal-vent-action[data-key="${flashKey}"] .portal-vent-action__img-wrap,` +
          `.portal-auto-others-group__cards .portal-vent-action[data-key="${flashKey}"] .portal-vent-action__img-wrap`
        );
        if (!$targets.length) return;
        // Set highlight instantly (no transition)
        $targets.css({ transition: 'none', boxShadow: '0 0 10px 2px rgba(60,103,79,0.55)', filter: 'brightness(1.18)', outline: '1.5px solid rgba(60,103,79,0.5)' });
        // After one frame, add transition and fade back to normal
        requestAnimationFrame(() => {
          $targets.css({ transition: 'box-shadow 0.5s ease-out, filter 0.5s ease-out, outline-color 0.5s ease-out', boxShadow: 'none', filter: '', outline: '1.5px solid transparent' });
          setTimeout(() => $targets.css({ transition: '', boxShadow: '', filter: '', outline: '' }), 550);
        });
      }));
    }

    // Position portal: restore saved position if it was already open,
    // otherwise anchor to icon container (same logic as icon click handler)
    if ($(window).width() > 1024) {
      portalContent.css({ right: 'auto', bottom: 'auto' });
      if (savedOffset) {
        portalContent.offset(savedOffset);
      } else {
        const iconContainer = $(".icon_container");
        if (iconContainer.length) {
          portalContent.offset(iconContainer.offset());
        }
      }
    }

    return portalContent;
  }


  const ACCESSORY_PORTAL_MAP = {
    mosquitoDoor: 10, extraDoor: 10, extraDoubleDoor: 10,
    automateOpening: 11, roofWindow: 11, sideWindow: 11, backWindow: 11,
    woodTable1Win: 12, woodTable3Win: 12, woodShelf1Win: 12, woodShelf3Win: 12,
    plasticTable1Win: 12, plasticTable3Win: 12, plasticShelf1Win: 12, plasticShelf3Win: 12,
    cultivationTable3Win: 12, aluminumTable2Win: 12, aluminumShelf2Win: 12, set2Shelves: 12,
    veil: 13, downpipes: 13, roofDecor: 13,
  };

  const onAccessoryPlacedGlobal = (e) => {
    const key = e?.detail?.key;

    if (!key || e?.detail?.zone === undefined) return;
    const portalId = ACCESSORY_PORTAL_MAP[key];
    if (!portalId) return;

    setTimeout(() => {
      const $icon = $(`#${portalId}`);
      const isPortalOpen = $icon.hasClass(`sun__icon-active--${portalId}`);
      if (!isPortalOpen) {
        // flash anition
        window._ventFlashKey = key;

        $('.sun__icon').removeClass((i, cls) => (cls.match(/sun__icon-active--\S+/g) || []).join(' '));
        $icon.show().addClass(`sun__icon-active--${portalId}`);
        state.portalOption = portalId;
        mainContent.find('.portal-container').remove();
        const portal = portalGenerete(true);
        if (!portal) return;
        $('.interface-container').addClass('interface-container-portal');
        if ($(window).width() > 1024) {
          const offset = $('.icon_container').offset();
          if (offset) portal.css({ top: offset.top, left: offset.left, right: 'auto', bottom: 'auto' });
        }
        pergola.update();
        // pergola.update() hides hotspots — restore them so user can continue placing.
        // veil/roofDecor are auto-placed with no hotspot; calling again would toggle them off.
        const AUTO_PLACED_KEYS = new Set(['veil', 'roofDecor']);
        if (!AUTO_PLACED_KEYS.has(key)) {
          showHotspotsForAccessory(key);
        }
      }
    }, 0);
  };

  window.addEventListener('accessoryPlaced', onAccessoryPlacedGlobal);

  const icons = $(`
    <div class="icon_wrap">
    <div class="left_button"></div>

    <div class="icon_container">

        <div class="sun__icon heaters__icon" id="6" data-value="LED Lights">
          <span class="sun__icon__img" id="doors-slidding-icon" style="
              background-image: url(public/img/icons/led_light_icon.svg);
          "></span>
       </div>

       <div class="sun__icon shades__icon" id="${greenHouseConst.shape.Straight}" data-value="${greenHouseConst.shapeNames.Straight}">
          <span class="sun__icon__img" id="shades-n" style="
              background-image: url(public/img/icons/marevo-menu-blinds.svg);
          "></span>
       </div>

        <div class="sun__icon" id="${greenHouseConst.shape.Sloping}" data-value="${greenHouseConst.shapeNames.Sloping}">
          <span class="sun__icon__img" id="light-n" style="
              background-image: url(public/img/icons/marevo-menu-door-sliding-glass.svg);
          "></span>
       </div>

       <div class="sun__icon screen__icon" id="${greenHouseConst.shape.ExtraHigh}" data-value="${greenHouseConst.shapeNames.ExtraHigh}">
          <span class="sun__icon__img" id="screen-n" style="
              background-image: url(public/img/icons/marevo-menu-shutters-sliding.svg);
              background-position: center;
          "></span>
       </div>

       <div class="sun__icon blade__icon" id="10" data-value="Door Settings">
          <span class="sun__icon__img" id="doors-slidding-icon" style="
              background-image: url(public/img/icons/marevo-menu-door-sliding.svg);
          "></span>
       </div>

       <div class="sun__icon ventilation__icon" id="11" data-value="Ventilation">
          <span class="sun__icon__img" style="
              background-image: url(public/img/icons/marevo-menu-ventilation.svg);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              width: 32px;
              height: 32px;
              display: block;
          "></span>
       </div>

       <div class="sun__icon organization__icon" id="12" data-value="Organization" style="display:none">
          <span class="sun__icon__img" style="
              background-image: url(public/img/icons/marevo-menu-organization.svg);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              width: 32px;
              height: 32px;
              display: block;
          "></span>
       </div>

         <div class="sun__icon others__icon" id="13" data-value="Other" style="display:none">
          <span class="sun__icon__img" style="
              background-image: url(public/img/icons/marevo-menu-others.svg);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              width: 32px;
              height: 32px;
              display: block;
          "></span>
       </div>
    </div> 

    <div class="right_button"></div>
    </div>
    `);

  modelId.append(icons);

  function scrollLogic() {
    const $iconContainer = $(".icon_container");
    const $leftButton = $(".left_button");
    const $rightButton = $(".right_button");

    function updateButtonVisibility() {
      $(".icon_container").removeClass("icon_container-mobile");

      if ($iconContainer.scrollLeft() === 0) {
        $leftButton.hide();
      } else {
        $leftButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }

      if (
        $iconContainer.scrollLeft() + $iconContainer.innerWidth() >=
        $iconContainer[0].scrollWidth - 1
      ) {
        $rightButton.hide();
      } else {
        $rightButton.show();
        $(".icon_container").addClass("icon_container-mobile");
      }
    }

    updateButtonVisibility();

    $leftButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "-=50" },
        100,
        updateButtonVisibility
      );
    });

    $rightButton.on("click", function () {
      $iconContainer.animate(
        { scrollLeft: "+=50" },
        100,
        updateButtonVisibility
      );
    });

    $iconContainer.on("scroll", updateButtonVisibility);
  }

  const icon = icons.find(".sun__icon");
  const portalLight = mainContent.find(".portal-light");
  const sunIcon = icons.find("#light");

  //#region ICON LOGIC
  // INIT POP-UP
  setTimeout(() => {
    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  }, 500);

  icon.each(function () {
    const id = $(this).attr("id");

    $(this).on("click", function () {
      const alreadyActive = $(this).hasClass(`sun__icon-active--${id}`);

      icon.each(function () {
        $(this).removeClass(function (index, className) {
          return (className.match(/sun__icon-active--\S+/g) || []).join(" ");
        });
      });

      if (alreadyActive) {
        mainContent.find(".portal-container").remove();
        $(".interface-container").removeClass("interface-container-portal");
        pergola.update();
        return;
      }

      state.portalOption = +id;

      //blade rotation
      if (+id !== 10 && +id !== 7 && +id !== 6 && +id !== 11 && +id !== 12 && +id !== 13) {
        state.currentActiveSystems = +id;
      } else {
        state.currentActiveSystems = null;
      }

      $(this).toggleClass(`sun__icon-active--${id}`);

      mainContent.find(".portal-container").remove();
      const portal = portalGenerete(true);

      $(".interface-container").addClass("interface-container-portal");

      if ($(window).width() <= 1024) {
        portal.css({
          top: "",
          left: "",
          right: "",
        });
      } else {
        // Always anchor to the icon container so the portal appears in the same
        // spot regardless of which icon was clicked (avoids opening over the 3D scene).
        const iconContainer = $(".icon_container");
        const containerOffset = iconContainer.offset();
        portal.css({
          top: containerOffset.top,
          left: containerOffset.left,
          right: "auto",
          bottom: "auto",
        });
      }

      pergola.update();
    });
  });

  //#region CLOSE PORTAL
  $(document).on("click", ".portal-container__close", function () {
    $(".interface-container").removeClass("interface-container-portal");
    state.currentActiveSystems = null;

    // Stop portal popup mixer and raycast mixers, restore door + logos to rest.
    const gltf = IMPORTED_MODELS_GLTF[0];
    const model = gltf?.scene;

    if (window._doorMixer) {
      window._doorMixer.stopAllAction();
      window._doorMixer.setTime(0);
    }

    // Stop raycast-driven animations
    if (window._meshClickMixers?.length) {
      window._meshClickMixers.forEach(m => m.stopAllAction());
      window._meshClickMixers.length = 0;
    }

    // Reset door rotation only (undo animation swing) — keep left/right side position as-is
    const frontWall = model?.getObjectByName('front_wall');
    if (frontWall?.userData.originQuat) {
      frontWall.quaternion.copy(frontWall.userData.originQuat);
    }
    // Reset mosquito doors
    const frontMosquito = model?.getObjectByName('door_mosquito');
    if (frontMosquito?.userData.originQuat) {
      frontMosquito.quaternion.copy(frontMosquito.userData.originQuat);
    }
    const backMosquito = model?.getObjectByName('door_mosquito_back');
    if (backMosquito?.userData.originQuat) {
      backMosquito.quaternion.copy(backMosquito.userData.originQuat);
    }

    // Restore back door animation to rest position
    if (window._backDoorMixer) {
      window._backDoorMixer.stopAllAction();
      window._backDoorMixer.setTime(0);
    }
    const backDoor = model?.getObjectByName('back_wall_door');
    if (backDoor?.userData.originQuat) {
      backDoor.quaternion.copy(backDoor.userData.originQuat);
    }
    requestRender();

    // reset roof-window animations when popup closes
    if (window._roofWinMixers?.length) {
      window._roofWinMixers.forEach(mixer => {
        mixer.stopAllAction();
        mixer.setTime(0);
      });
      window._roofWinMixers = [];
      requestRender();
    }

    const existingPortal = mainContent.find(".portal-container");

    if (existingPortal.length > 0) {
      existingPortal.remove();
    }

    icon.each(function () {
      $(this).removeClass(function (_index, className) {
        return (className.match(/sun__icon-active--\S+/g) || []).join(" ");
      });
    });

    pergola.update();
  });

  // #endregion
  //#endregion

  //light range
  const customRange = generateRangeHTML(lightRange[0]);
  const customRangeShades = generateRangeHTML(shadesRange[0]);
  const rangeContainer = mainContent.find(".portal-light__range");
  const rangeContainerShades = mainContent.find(".portal-shades__range");
  const iconBlade = icons.find("#10");

  rangeContainer.append(customRange);
  rangeContainerShades.append(customRangeShades);

  // iconBlade.trigger("click");
  icon.hide();

  //DEFAULT door & downpipe POP UP
  setTimeout(() => {
    showIcon(10, false);
    showIcon(13, false);
  }, 4000);

  scrollLogic();

  $(window).on("resize", function () {
    $(".icon_container").trigger("scroll");

    icon.each(function () {
      const id = $(this).attr("id");
      const activeClass = `sun__icon-active--${id}`;

      if ($(this).hasClass(activeClass)) {
        $(this).trigger("click");
        return false;
      }
    });
  });

  return { portal: portalLight, sunIcon };
}
